import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SeriesSearchQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate = (
  { __typename?: 'ItemTemplate' }
  & Pick<Types.ItemTemplate, 'id'>
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Series_seriesName_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Series_description_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Series_image_ImageField = (
  { __typename?: 'ImageField' }
  & Pick<Types.ImageField, 'src' | 'alt'>
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
  & { seriesName: Types.Maybe<SeriesSearchQuery_search_ItemSearchResults_results_Series_seriesName_TextField>, description: Types.Maybe<SeriesSearchQuery_search_ItemSearchResults_results_Series_description_TextField>, image: Types.Maybe<SeriesSearchQuery_search_ItemSearchResults_results_Series_image_ImageField>, template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchQuery_search_ItemSearchResults_results = SeriesSearchQuery_search_ItemSearchResults_results_Accordion | SeriesSearchQuery_search_ItemSearchResults_results_AccordionFolder | SeriesSearchQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | SeriesSearchQuery_search_ItemSearchResults_results_AccordionItem | SeriesSearchQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | SeriesSearchQuery_search_ItemSearchResults_results_AccordionParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_AccordionPresentation | SeriesSearchQuery_search_ItemSearchResults_results_AccordionPresentationFolder | SeriesSearchQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 | SeriesSearchQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | SeriesSearchQuery_search_ItemSearchResults_results_AddItem | SeriesSearchQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 | SeriesSearchQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | SeriesSearchQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb | SeriesSearchQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | SeriesSearchQuery_search_ItemSearchResults_results_AddThisParameters | SeriesSearchQuery_search_ItemSearchResults_results_AggregatedFacetFilter | SeriesSearchQuery_search_ItemSearchResults_results_AlertMessage | SeriesSearchQuery_search_ItemSearchResults_results_AlertMessageFolder | SeriesSearchQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_AlertMessageType | SeriesSearchQuery_search_ItemSearchResults_results_AllertMessageTypeFolder | SeriesSearchQuery_search_ItemSearchResults_results_Archive | SeriesSearchQuery_search_ItemSearchResults_results_ArticleAuthor | SeriesSearchQuery_search_ItemSearchResults_results_ArticleAuthorsFolder | SeriesSearchQuery_search_ItemSearchResults_results_ArticleCategoriesFolder | SeriesSearchQuery_search_ItemSearchResults_results_ArticleCategory | SeriesSearchQuery_search_ItemSearchResults_results_ArticleChapter | SeriesSearchQuery_search_ItemSearchResults_results_ArticleChapters | SeriesSearchQuery_search_ItemSearchResults_results_ArticleContentType | SeriesSearchQuery_search_ItemSearchResults_results_ArticleContentTypesFolder | SeriesSearchQuery_search_ItemSearchResults_results_ArticleFilter | SeriesSearchQuery_search_ItemSearchResults_results_ArticleFilterOption | SeriesSearchQuery_search_ItemSearchResults_results_ArticleFootnote | SeriesSearchQuery_search_ItemSearchResults_results_ArticleFootnoteLink | SeriesSearchQuery_search_ItemSearchResults_results_ArticleFootnoteText | SeriesSearchQuery_search_ItemSearchResults_results_ArticleInfogramTile | SeriesSearchQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_ArticlePage | SeriesSearchQuery_search_ItemSearchResults_results_ArticleRegion | SeriesSearchQuery_search_ItemSearchResults_results_ArticleRegionsFolder | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSeriesCollection | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSeriesFolder | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSettings | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner | SeriesSearchQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder | SeriesSearchQuery_search_ItemSearchResults_results_ArticleTag | SeriesSearchQuery_search_ItemSearchResults_results_ArticleTagsFolder | SeriesSearchQuery_search_ItemSearchResults_results_ArticleTeamAuthor | SeriesSearchQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | SeriesSearchQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | SeriesSearchQuery_search_ItemSearchResults_results_ArticlesGroupFolder | SeriesSearchQuery_search_ItemSearchResults_results_AttachThemeExtension | SeriesSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListings | SeriesSearchQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_AvailableJSONRenderings | SeriesSearchQuery_search_ItemSearchResults_results_AvailableMetaRenderings | SeriesSearchQuery_search_ItemSearchResults_results_AvailableRenderings | SeriesSearchQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | SeriesSearchQuery_search_ItemSearchResults_results_AwardsBanner | SeriesSearchQuery_search_ItemSearchResults_results_AwardsBannerFolder | SeriesSearchQuery_search_ItemSearchResults_results_AwardsBannerImage | SeriesSearchQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_BackgroundColorOption | SeriesSearchQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder | SeriesSearchQuery_search_ItemSearchResults_results_BannerFolder | SeriesSearchQuery_search_ItemSearchResults_results_BannerType | SeriesSearchQuery_search_ItemSearchResults_results_BannerTypeFolder | SeriesSearchQuery_search_ItemSearchResults_results_BaseHeading | SeriesSearchQuery_search_ItemSearchResults_results_BaseHeadingFolder | SeriesSearchQuery_search_ItemSearchResults_results_BoolFacet | SeriesSearchQuery_search_ItemSearchResults_results_BranchesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Breadcrumb | SeriesSearchQuery_search_ItemSearchResults_results_BrowserTitleDefinition | SeriesSearchQuery_search_ItemSearchResults_results_CORSEntry | SeriesSearchQuery_search_ItemSearchResults_results_CORSGrouping | SeriesSearchQuery_search_ItemSearchResults_results_CTAPresentationType | SeriesSearchQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__AbrdnPage | SeriesSearchQuery_search_ItemSearchResults_results_C__ActionBase | SeriesSearchQuery_search_ItemSearchResults_results_C__AdvancedParameter | SeriesSearchQuery_search_ItemSearchResults_results_C__App | SeriesSearchQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | SeriesSearchQuery_search_ItemSearchResults_results_C__ArticleWildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_C__BaseCTA | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 | SeriesSearchQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | SeriesSearchQuery_search_ItemSearchResults_results_C__BaseRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_C__BaseTheme | SeriesSearchQuery_search_ItemSearchResults_results_C__BaseVariantField | SeriesSearchQuery_search_ItemSearchResults_results_C__Class | SeriesSearchQuery_search_ItemSearchResults_results_C__CompositeGroup | SeriesSearchQuery_search_ItemSearchResults_results_C__CompositeSection | SeriesSearchQuery_search_ItemSearchResults_results_C__EloquaForm | SeriesSearchQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | SeriesSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions | SeriesSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | SeriesSearchQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | SeriesSearchQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase | SeriesSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | SeriesSearchQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | SeriesSearchQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | SeriesSearchQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | SeriesSearchQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | SeriesSearchQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior | SeriesSearchQuery_search_ItemSearchResults_results_C__GridDefinition | SeriesSearchQuery_search_ItemSearchResults_results_C__GridItemBase | SeriesSearchQuery_search_ItemSearchResults_results_C__GridParameters | SeriesSearchQuery_search_ItemSearchResults_results_C__HeadlessSite | SeriesSearchQuery_search_ItemSearchResults_results_C__HeadlessTenant | SeriesSearchQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | SeriesSearchQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | SeriesSearchQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | SeriesSearchQuery_search_ItemSearchResults_results_C__IAllowEmpty | SeriesSearchQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition | SeriesSearchQuery_search_ItemSearchResults_results_C__IBoosting | SeriesSearchQuery_search_ItemSearchResults_results_C__ICacheable | SeriesSearchQuery_search_ItemSearchResults_results_C__ICompatibleRenderings | SeriesSearchQuery_search_ItemSearchResults_results_C__IComponentVariant | SeriesSearchQuery_search_ItemSearchResults_results_C__IControlType | SeriesSearchQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder | SeriesSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates | SeriesSearchQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL | SeriesSearchQuery_search_ItemSearchResults_results_C__IIcon | SeriesSearchQuery_search_ItemSearchResults_results_C__ILocation | SeriesSearchQuery_search_ItemSearchResults_results_C__IPaginable | SeriesSearchQuery_search_ItemSearchResults_results_C__IPagination | SeriesSearchQuery_search_ItemSearchResults_results_C__IPoi | SeriesSearchQuery_search_ItemSearchResults_results_C__IRenderingId | SeriesSearchQuery_search_ItemSearchResults_results_C__ISplitter | SeriesSearchQuery_search_ItemSearchResults_results_C__IStyling | SeriesSearchQuery_search_ItemSearchResults_results_C__IVariantDefinition | SeriesSearchQuery_search_ItemSearchResults_results_C__InvestmentTrustPage | SeriesSearchQuery_search_ItemSearchResults_results_C__JSONField | SeriesSearchQuery_search_ItemSearchResults_results_C__JSONReference | SeriesSearchQuery_search_ItemSearchResults_results_C__JSSData | SeriesSearchQuery_search_ItemSearchResults_results_C__JSSSettings | SeriesSearchQuery_search_ItemSearchResults_results_C__JSSSiteFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__JssRootFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | SeriesSearchQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed | SeriesSearchQuery_search_ItemSearchResults_results_C__Page | SeriesSearchQuery_search_ItemSearchResults_results_C__PageData | SeriesSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | SeriesSearchQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesign | SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | SeriesSearchQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | SeriesSearchQuery_search_ItemSearchResults_results_C__PlaceholderWrapper | SeriesSearchQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | SeriesSearchQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | SeriesSearchQuery_search_ItemSearchResults_results_C__RedirectMapGrouping | SeriesSearchQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | SeriesSearchQuery_search_ItemSearchResults_results_C__Route | SeriesSearchQuery_search_ItemSearchResults_results_C__SimpleVideo | SeriesSearchQuery_search_ItemSearchResults_results_C__SiteSettingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__SitemapSettings | SeriesSearchQuery_search_ItemSearchResults_results_C__StandardTemplate | SeriesSearchQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | SeriesSearchQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | SeriesSearchQuery_search_ItemSearchResults_results_C__TrustFolder | SeriesSearchQuery_search_ItemSearchResults_results_C__VariantDefinition | SeriesSearchQuery_search_ItemSearchResults_results_C__VariantField | SeriesSearchQuery_search_ItemSearchResults_results_C__VariantsGrouping | SeriesSearchQuery_search_ItemSearchResults_results_C___AdvancedItem | SeriesSearchQuery_search_ItemSearchResults_results_C___Arguments | SeriesSearchQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | SeriesSearchQuery_search_ItemSearchResults_results_C___Article | SeriesSearchQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow | SeriesSearchQuery_search_ItemSearchResults_results_C___ArticleSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_C___ArticleWildcard | SeriesSearchQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseArticle | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseDataFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseHelpArticle | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseJSSTenant | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePage | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePageDesign | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePageDesignFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePartialDesign | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePlaceholder | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePresentation | SeriesSearchQuery_search_ItemSearchResults_results_C___BasePressRelease | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSettings | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteDefinition | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteGrouping | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseSiteRoot | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseTenant | SeriesSearchQuery_search_ItemSearchResults_results_C___BaseTenantFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___BucketRules | SeriesSearchQuery_search_ItemSearchResults_results_C___CORS | SeriesSearchQuery_search_ItemSearchResults_results_C___Content | SeriesSearchQuery_search_ItemSearchResults_results_C___ContentType | SeriesSearchQuery_search_ItemSearchResults_results_C___DataAttributes | SeriesSearchQuery_search_ItemSearchResults_results_C___DatasourceWorkflow | SeriesSearchQuery_search_ItemSearchResults_results_C___Dependencies | SeriesSearchQuery_search_ItemSearchResults_results_C___Description | SeriesSearchQuery_search_ItemSearchResults_results_C___DesignTemplateMapping | SeriesSearchQuery_search_ItemSearchResults_results_C___Designable | SeriesSearchQuery_search_ItemSearchResults_results_C___EditType | SeriesSearchQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 | SeriesSearchQuery_search_ItemSearchResults_results_C___EditingTheme | SeriesSearchQuery_search_ItemSearchResults_results_C___Enabled | SeriesSearchQuery_search_ItemSearchResults_results_C___ErrorHandling | SeriesSearchQuery_search_ItemSearchResults_results_C___ExternalArticle | SeriesSearchQuery_search_ItemSearchResults_results_C___Fields | SeriesSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesParent | SeriesSearchQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard | SeriesSearchQuery_search_ItemSearchResults_results_C___Footnotes | SeriesSearchQuery_search_ItemSearchResults_results_C___FundDetailsWildcard | SeriesSearchQuery_search_ItemSearchResults_results_C___FundFormAvailability | SeriesSearchQuery_search_ItemSearchResults_results_C___FundMetadataPage | SeriesSearchQuery_search_ItemSearchResults_results_C___FundSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_C___FundsFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___FundsFormsFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard | SeriesSearchQuery_search_ItemSearchResults_results_C___GridMapping | SeriesSearchQuery_search_ItemSearchResults_results_C___HelpArticle | SeriesSearchQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_C___HelpArticleWildcard | SeriesSearchQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping | SeriesSearchQuery_search_ItemSearchResults_results_C___Icon | SeriesSearchQuery_search_ItemSearchResults_results_C___IncludeByDefault | SeriesSearchQuery_search_ItemSearchResults_results_C___IncludeIfInstalled | SeriesSearchQuery_search_ItemSearchResults_results_C___InternalArticle | SeriesSearchQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode | SeriesSearchQuery_search_ItemSearchResults_results_C___IsSystemModule | SeriesSearchQuery_search_ItemSearchResults_results_C___JSONVariantPaging | SeriesSearchQuery_search_ItemSearchResults_results_C___JSONVariantsBase | SeriesSearchQuery_search_ItemSearchResults_results_C___LimitedDisplay | SeriesSearchQuery_search_ItemSearchResults_results_C___LinkAttributes | SeriesSearchQuery_search_ItemSearchResults_results_C___LinkSettings | SeriesSearchQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_C___ManualKeyInformation | SeriesSearchQuery_search_ItemSearchResults_results_C___MemberOf | SeriesSearchQuery_search_ItemSearchResults_results_C___MetadataPage | SeriesSearchQuery_search_ItemSearchResults_results_C___Modules | SeriesSearchQuery_search_ItemSearchResults_results_C___Name | SeriesSearchQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | SeriesSearchQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa | SeriesSearchQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 | SeriesSearchQuery_search_ItemSearchResults_results_C___Navigable | SeriesSearchQuery_search_ItemSearchResults_results_C___NavigablePage | SeriesSearchQuery_search_ItemSearchResults_results_C___PageContent | SeriesSearchQuery_search_ItemSearchResults_results_C___PageWorkflow | SeriesSearchQuery_search_ItemSearchResults_results_C___PerSiteStandardValues | SeriesSearchQuery_search_ItemSearchResults_results_C___Podcast | SeriesSearchQuery_search_ItemSearchResults_results_C___PodcastPressRelease | SeriesSearchQuery_search_ItemSearchResults_results_C___PremiumContentPage | SeriesSearchQuery_search_ItemSearchResults_results_C___PressRelease | SeriesSearchQuery_search_ItemSearchResults_results_C___PressReleaseContentType | SeriesSearchQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_C___PressReleaseWildcard | SeriesSearchQuery_search_ItemSearchResults_results_C___ProtectedTheme | SeriesSearchQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate | SeriesSearchQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters | SeriesSearchQuery_search_ItemSearchResults_results_C___RenderingVariantsBase | SeriesSearchQuery_search_ItemSearchResults_results_C___RenderingsList | SeriesSearchQuery_search_ItemSearchResults_results_C___RobotsContent | SeriesSearchQuery_search_ItemSearchResults_results_C___RoleDomain | SeriesSearchQuery_search_ItemSearchResults_results_C___RoleName | SeriesSearchQuery_search_ItemSearchResults_results_C___RoleType | SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations | SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldId | SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle | SeriesSearchQuery_search_ItemSearchResults_results_C___SalesforceFieldValue | SeriesSearchQuery_search_ItemSearchResults_results_C___Script | SeriesSearchQuery_search_ItemSearchResults_results_C___SearchSignature | SeriesSearchQuery_search_ItemSearchResults_results_C___Searchable | SeriesSearchQuery_search_ItemSearchResults_results_C___SecurityItemPointer | SeriesSearchQuery_search_ItemSearchResults_results_C___SharedArticles | SeriesSearchQuery_search_ItemSearchResults_results_C___SharedContent | SeriesSearchQuery_search_ItemSearchResults_results_C___SharedHelpArticles | SeriesSearchQuery_search_ItemSearchResults_results_C___SharedPage | SeriesSearchQuery_search_ItemSearchResults_results_C___SharedPressReleases | SeriesSearchQuery_search_ItemSearchResults_results_C___SharedRoot | SeriesSearchQuery_search_ItemSearchResults_results_C___SharedSettings | SeriesSearchQuery_search_ItemSearchResults_results_C___SiteContent | SeriesSearchQuery_search_ItemSearchResults_results_C___SiteFolder | SeriesSearchQuery_search_ItemSearchResults_results_C___SiteMediaLibrary | SeriesSearchQuery_search_ItemSearchResults_results_C___SiteSettings | SeriesSearchQuery_search_ItemSearchResults_results_C___SiteTemplate | SeriesSearchQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging | SeriesSearchQuery_search_ItemSearchResults_results_C___Sitemap | SeriesSearchQuery_search_ItemSearchResults_results_C___SitemapMediaItems | SeriesSearchQuery_search_ItemSearchResults_results_C___SlidersRangeSettings | SeriesSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateContent | SeriesSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription | SeriesSearchQuery_search_ItemSearchResults_results_C___SolutionTemplateName | SeriesSearchQuery_search_ItemSearchResults_results_C___SortOrder | SeriesSearchQuery_search_ItemSearchResults_results_C___StackBreakpoint | SeriesSearchQuery_search_ItemSearchResults_results_C___Statistics | SeriesSearchQuery_search_ItemSearchResults_results_C___SupportedLanguages | SeriesSearchQuery_search_ItemSearchResults_results_C___Taggable | SeriesSearchQuery_search_ItemSearchResults_results_C___TeamMembersParentPage | SeriesSearchQuery_search_ItemSearchResults_results_C___TeamMembersWildcard | SeriesSearchQuery_search_ItemSearchResults_results_C___TechzoneArticle | SeriesSearchQuery_search_ItemSearchResults_results_C___Template | SeriesSearchQuery_search_ItemSearchResults_results_C___Title | SeriesSearchQuery_search_ItemSearchResults_results_C___Type | SeriesSearchQuery_search_ItemSearchResults_results_C___Validation | SeriesSearchQuery_search_ItemSearchResults_results_C___VariantPaging | SeriesSearchQuery_search_ItemSearchResults_results_C___VectorTile | SeriesSearchQuery_search_ItemSearchResults_results_C___VectorTileLink | SeriesSearchQuery_search_ItemSearchResults_results_C___Video | SeriesSearchQuery_search_ItemSearchResults_results_C___VideoPressRelease | SeriesSearchQuery_search_ItemSearchResults_results_C___Width | SeriesSearchQuery_search_ItemSearchResults_results_C___WildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_CacheSetting | SeriesSearchQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 | SeriesSearchQuery_search_ItemSearchResults_results_CalendarEvent | SeriesSearchQuery_search_ItemSearchResults_results_CallOutSection | SeriesSearchQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption | SeriesSearchQuery_search_ItemSearchResults_results_CallOutSectionFolder | SeriesSearchQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_CallToAction | SeriesSearchQuery_search_ItemSearchResults_results_CallToActionFolder | SeriesSearchQuery_search_ItemSearchResults_results_CapabilitiesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Capability | SeriesSearchQuery_search_ItemSearchResults_results_CapabilityMap | SeriesSearchQuery_search_ItemSearchResults_results_CapabilityMappings | SeriesSearchQuery_search_ItemSearchResults_results_Carousel | SeriesSearchQuery_search_ItemSearchResults_results_CarouselFolder | SeriesSearchQuery_search_ItemSearchResults_results_CarouselSlide | SeriesSearchQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | SeriesSearchQuery_search_ItemSearchResults_results_Checkbox | SeriesSearchQuery_search_ItemSearchResults_results_ChecklistFilter | SeriesSearchQuery_search_ItemSearchResults_results_ChecklistFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | SeriesSearchQuery_search_ItemSearchResults_results_ColumnSplitter | SeriesSearchQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | SeriesSearchQuery_search_ItemSearchResults_results_CompatibilityMode | SeriesSearchQuery_search_ItemSearchResults_results_ComponentConfiguration | SeriesSearchQuery_search_ItemSearchResults_results_ComponentThemeConfiguration | SeriesSearchQuery_search_ItemSearchResults_results_ComponentThemesConfiguration | SeriesSearchQuery_search_ItemSearchResults_results_ComponentsConfigurations | SeriesSearchQuery_search_ItemSearchResults_results_ConfigurationFolder | SeriesSearchQuery_search_ItemSearchResults_results_Container | SeriesSearchQuery_search_ItemSearchResults_results_ContainerOption | SeriesSearchQuery_search_ItemSearchResults_results_ContainerOptionsFolder | SeriesSearchQuery_search_ItemSearchResults_results_ContainerParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f | SeriesSearchQuery_search_ItemSearchResults_results_ContentBlock | SeriesSearchQuery_search_ItemSearchResults_results_ContentBlockFolder | SeriesSearchQuery_search_ItemSearchResults_results_ContentToken | SeriesSearchQuery_search_ItemSearchResults_results_ContentTokenFolder | SeriesSearchQuery_search_ItemSearchResults_results_ContentType | SeriesSearchQuery_search_ItemSearchResults_results_CorporateTheme | SeriesSearchQuery_search_ItemSearchResults_results_CorporateThemesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Country | SeriesSearchQuery_search_ItemSearchResults_results_CountryISOCode | SeriesSearchQuery_search_ItemSearchResults_results_CountryISOCodesFolder | SeriesSearchQuery_search_ItemSearchResults_results_CustomerReviewFolder | SeriesSearchQuery_search_ItemSearchResults_results_CustomerReviewTile | SeriesSearchQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap | SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeFund | SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeFundRangeName | SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_DataBridgeShareClass | SeriesSearchQuery_search_ItemSearchResults_results_DataFolder | SeriesSearchQuery_search_ItemSearchResults_results_DatasourceConfiguration | SeriesSearchQuery_search_ItemSearchResults_results_DatasourceConfigurations | SeriesSearchQuery_search_ItemSearchResults_results_DatasourceWorkflowAction | SeriesSearchQuery_search_ItemSearchResults_results_DateFacet | SeriesSearchQuery_search_ItemSearchResults_results_DateFilter | SeriesSearchQuery_search_ItemSearchResults_results_DateFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | SeriesSearchQuery_search_ItemSearchResults_results_DefaultColumnLayout | SeriesSearchQuery_search_ItemSearchResults_results_DefaultShareclassMapping | SeriesSearchQuery_search_ItemSearchResults_results_DefaultShareclassMappings | SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlight | SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder | SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightItem | SeriesSearchQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Device | SeriesSearchQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 | SeriesSearchQuery_search_ItemSearchResults_results_Devices | SeriesSearchQuery_search_ItemSearchResults_results_DictionaryFolder | SeriesSearchQuery_search_ItemSearchResults_results_DisqusParameters | SeriesSearchQuery_search_ItemSearchResults_results_DistanceFacet | SeriesSearchQuery_search_ItemSearchResults_results_Divider | SeriesSearchQuery_search_ItemSearchResults_results_DocumentItem | SeriesSearchQuery_search_ItemSearchResults_results_DocumentListings | SeriesSearchQuery_search_ItemSearchResults_results_DocumentListingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_DocumentTypeFolder | SeriesSearchQuery_search_ItemSearchResults_results_DominantLanguageMapping | SeriesSearchQuery_search_ItemSearchResults_results_Dropdown | SeriesSearchQuery_search_ItemSearchResults_results_DropdownFilter | SeriesSearchQuery_search_ItemSearchResults_results_DropdownFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | SeriesSearchQuery_search_ItemSearchResults_results_EditEditingTheme | SeriesSearchQuery_search_ItemSearchResults_results_EditFrame | SeriesSearchQuery_search_ItemSearchResults_results_EditModePanel | SeriesSearchQuery_search_ItemSearchResults_results_EditSiteItem | SeriesSearchQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | SeriesSearchQuery_search_ItemSearchResults_results_EditSiteTheme | SeriesSearchQuery_search_ItemSearchResults_results_EditTenantTemplate | SeriesSearchQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | SeriesSearchQuery_search_ItemSearchResults_results_EditType | SeriesSearchQuery_search_ItemSearchResults_results_EloquaFormFolder | SeriesSearchQuery_search_ItemSearchResults_results_EloquaFundForm | SeriesSearchQuery_search_ItemSearchResults_results_Enum | SeriesSearchQuery_search_ItemSearchResults_results_Enums | SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage | SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d | SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 | SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | SeriesSearchQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | SeriesSearchQuery_search_ItemSearchResults_results_EventCalendarParameters | SeriesSearchQuery_search_ItemSearchResults_results_EventList | SeriesSearchQuery_search_ItemSearchResults_results_EventListParameters | SeriesSearchQuery_search_ItemSearchResults_results_EventTypes | SeriesSearchQuery_search_ItemSearchResults_results_EventsFolder | SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript | SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | SeriesSearchQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | SeriesSearchQuery_search_ItemSearchResults_results_ExtendSiteTheme | SeriesSearchQuery_search_ItemSearchResults_results_ExternalLiterature | SeriesSearchQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_FacetSlider | SeriesSearchQuery_search_ItemSearchResults_results_FacetSliderFolder | SeriesSearchQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | SeriesSearchQuery_search_ItemSearchResults_results_FacetSummary | SeriesSearchQuery_search_ItemSearchResults_results_FacetSummaryFolder | SeriesSearchQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | SeriesSearchQuery_search_ItemSearchResults_results_FacetsGrouping | SeriesSearchQuery_search_ItemSearchResults_results_FakeNavigationItem | SeriesSearchQuery_search_ItemSearchResults_results_FeatureBanner | SeriesSearchQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_FeaturedArticles | SeriesSearchQuery_search_ItemSearchResults_results_FeaturedArticlesFolder | SeriesSearchQuery_search_ItemSearchResults_results_FeaturedTheme | SeriesSearchQuery_search_ItemSearchResults_results_FeaturedThemesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Feed | SeriesSearchQuery_search_ItemSearchResults_results_FeedFolder | SeriesSearchQuery_search_ItemSearchResults_results_FeedParameters | SeriesSearchQuery_search_ItemSearchResults_results_FieldEditor | SeriesSearchQuery_search_ItemSearchResults_results_FieldRenderer | SeriesSearchQuery_search_ItemSearchResults_results_FileList | SeriesSearchQuery_search_ItemSearchResults_results_FileListFolder | SeriesSearchQuery_search_ItemSearchResults_results_FileListParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 | SeriesSearchQuery_search_ItemSearchResults_results_FilterCriteria | SeriesSearchQuery_search_ItemSearchResults_results_FilterCriteriaFolder | SeriesSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOption | SeriesSearchQuery_search_ItemSearchResults_results_FilterTaxonomyOptions | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | SeriesSearchQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | SeriesSearchQuery_search_ItemSearchResults_results_Flip | SeriesSearchQuery_search_ItemSearchResults_results_FlipFolder | SeriesSearchQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 | SeriesSearchQuery_search_ItemSearchResults_results_Flipside | SeriesSearchQuery_search_ItemSearchResults_results_FloatFacet | SeriesSearchQuery_search_ItemSearchResults_results_Footer | SeriesSearchQuery_search_ItemSearchResults_results_FooterFolder | SeriesSearchQuery_search_ItemSearchResults_results_FooterLink | SeriesSearchQuery_search_ItemSearchResults_results_FormRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_FundAssetClass | SeriesSearchQuery_search_ItemSearchResults_results_FundAssetClassesFolder | SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | SeriesSearchQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | SeriesSearchQuery_search_ItemSearchResults_results_FundFormsFolder | SeriesSearchQuery_search_ItemSearchResults_results_FundInFocus | SeriesSearchQuery_search_ItemSearchResults_results_FundInFocusShareClass | SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f | SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c | SeriesSearchQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | SeriesSearchQuery_search_ItemSearchResults_results_FundSettings | SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | SeriesSearchQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | SeriesSearchQuery_search_ItemSearchResults_results_FundSubAssetClass | SeriesSearchQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder | SeriesSearchQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder | SeriesSearchQuery_search_ItemSearchResults_results_FundsFolder | SeriesSearchQuery_search_ItemSearchResults_results_FundsInFocusFolder | SeriesSearchQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_FundsLiteratureFolder | SeriesSearchQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_Gallery | SeriesSearchQuery_search_ItemSearchResults_results_GalleryFolder | SeriesSearchQuery_search_ItemSearchResults_results_GalleryImage | SeriesSearchQuery_search_ItemSearchResults_results_GalleryParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_GalleryVideo | SeriesSearchQuery_search_ItemSearchResults_results_GatedAccordionContainer | SeriesSearchQuery_search_ItemSearchResults_results_GlobalLanguageSelector | SeriesSearchQuery_search_ItemSearchResults_results_GlobalNavigationBar | SeriesSearchQuery_search_ItemSearchResults_results_GoogleAnalytics | SeriesSearchQuery_search_ItemSearchResults_results_GoogleTagManager | SeriesSearchQuery_search_ItemSearchResults_results_GoogleTagManagerFolder | SeriesSearchQuery_search_ItemSearchResults_results_GridSetup | SeriesSearchQuery_search_ItemSearchResults_results_GridTheme | SeriesSearchQuery_search_ItemSearchResults_results_HTMLCode | SeriesSearchQuery_search_ItemSearchResults_results_HTMLCodeFolder | SeriesSearchQuery_search_ItemSearchResults_results_HTMLInclude | SeriesSearchQuery_search_ItemSearchResults_results_HTMLIncludesFolder | SeriesSearchQuery_search_ItemSearchResults_results_HTMLSnippet | SeriesSearchQuery_search_ItemSearchResults_results_HTMLSnippetFolder | SeriesSearchQuery_search_ItemSearchResults_results_HTMLTag | SeriesSearchQuery_search_ItemSearchResults_results_Header | SeriesSearchQuery_search_ItemSearchResults_results_HeaderFolder | SeriesSearchQuery_search_ItemSearchResults_results_Heading | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessTrustSite | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessVariants | SeriesSearchQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePage | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatform | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMap | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleTag | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleTagsFolder | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | SeriesSearchQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder | SeriesSearchQuery_search_ItemSearchResults_results_HelpTagMap | SeriesSearchQuery_search_ItemSearchResults_results_HelpTagMappings | SeriesSearchQuery_search_ItemSearchResults_results_HeroBanner | SeriesSearchQuery_search_ItemSearchResults_results_Highlight | SeriesSearchQuery_search_ItemSearchResults_results_HighlightBlock | SeriesSearchQuery_search_ItemSearchResults_results_HighlightBlockFolder | SeriesSearchQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_HighlightFolder | SeriesSearchQuery_search_ItemSearchResults_results_HighlightItem | SeriesSearchQuery_search_ItemSearchResults_results_HighlightParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Home | SeriesSearchQuery_search_ItemSearchResults_results_HomePage | SeriesSearchQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 | SeriesSearchQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 | SeriesSearchQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 | SeriesSearchQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 | SeriesSearchQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 | SeriesSearchQuery_search_ItemSearchResults_results_IFrame | SeriesSearchQuery_search_ItemSearchResults_results_IFrameFolder | SeriesSearchQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | SeriesSearchQuery_search_ItemSearchResults_results_IFrameParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 | SeriesSearchQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 | SeriesSearchQuery_search_ItemSearchResults_results_Icon | SeriesSearchQuery_search_ItemSearchResults_results_IconFolder | SeriesSearchQuery_search_ItemSearchResults_results_Image | SeriesSearchQuery_search_ItemSearchResults_results_ImageFolder | SeriesSearchQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 | SeriesSearchQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | SeriesSearchQuery_search_ItemSearchResults_results_ImageParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a | SeriesSearchQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 | SeriesSearchQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 | SeriesSearchQuery_search_ItemSearchResults_results_Infographics | SeriesSearchQuery_search_ItemSearchResults_results_InfographicsFolder | SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep | SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | SeriesSearchQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | SeriesSearchQuery_search_ItemSearchResults_results_IntegerFacet | SeriesSearchQuery_search_ItemSearchResults_results_IntroCopy | SeriesSearchQuery_search_ItemSearchResults_results_IntroCopyFolder | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegion | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyle | SeriesSearchQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder | SeriesSearchQuery_search_ItemSearchResults_results_InvestorType | SeriesSearchQuery_search_ItemSearchResults_results_InvestorTypesFolder | SeriesSearchQuery_search_ItemSearchResults_results_ItemQueriesFolder | SeriesSearchQuery_search_ItemSearchResults_results_ItemRights | SeriesSearchQuery_search_ItemSearchResults_results_JSBeaconSettings | SeriesSearchQuery_search_ItemSearchResults_results_JSONCheckbox | SeriesSearchQuery_search_ItemSearchResults_results_JSONContent | SeriesSearchQuery_search_ItemSearchResults_results_JSONDate | SeriesSearchQuery_search_ItemSearchResults_results_JSONFile | SeriesSearchQuery_search_ItemSearchResults_results_JSONImage | SeriesSearchQuery_search_ItemSearchResults_results_JSONLayout | SeriesSearchQuery_search_ItemSearchResults_results_JSONList | SeriesSearchQuery_search_ItemSearchResults_results_JSONMultilistReference | SeriesSearchQuery_search_ItemSearchResults_results_JSONPlaceholder | SeriesSearchQuery_search_ItemSearchResults_results_JSONQuery | SeriesSearchQuery_search_ItemSearchResults_results_JSONResults | SeriesSearchQuery_search_ItemSearchResults_results_JSONRichText | SeriesSearchQuery_search_ItemSearchResults_results_JSONScriban | SeriesSearchQuery_search_ItemSearchResults_results_JSONSection | SeriesSearchQuery_search_ItemSearchResults_results_JSONTemplate | SeriesSearchQuery_search_ItemSearchResults_results_JSONText | SeriesSearchQuery_search_ItemSearchResults_results_JSONToken | SeriesSearchQuery_search_ItemSearchResults_results_JSONVariantDefinition | SeriesSearchQuery_search_ItemSearchResults_results_JSONVariants | SeriesSearchQuery_search_ItemSearchResults_results_JSSLayout | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | SeriesSearchQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | SeriesSearchQuery_search_ItemSearchResults_results_JSSSiteGrouping | SeriesSearchQuery_search_ItemSearchResults_results_JSSTenantFolder | SeriesSearchQuery_search_ItemSearchResults_results_JavaScriptRendering | SeriesSearchQuery_search_ItemSearchResults_results_JsonRendering | SeriesSearchQuery_search_ItemSearchResults_results_JurisdictionStatus | SeriesSearchQuery_search_ItemSearchResults_results_JurisdictionsFolder | SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlightItem | SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlights | SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlightsFolder | SeriesSearchQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Language | SeriesSearchQuery_search_ItemSearchResults_results_LanguageSelector | SeriesSearchQuery_search_ItemSearchResults_results_LanguagesFolder | SeriesSearchQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_LayoutServiceVariants | SeriesSearchQuery_search_ItemSearchResults_results_LimitedDisplayFolder | SeriesSearchQuery_search_ItemSearchResults_results_LimitedDisplayOption | SeriesSearchQuery_search_ItemSearchResults_results_Link | SeriesSearchQuery_search_ItemSearchResults_results_LinkList | SeriesSearchQuery_search_ItemSearchResults_results_LinkListFolder | SeriesSearchQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | SeriesSearchQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 | SeriesSearchQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | SeriesSearchQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | SeriesSearchQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | SeriesSearchQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 | SeriesSearchQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 | SeriesSearchQuery_search_ItemSearchResults_results_LinksFolder | SeriesSearchQuery_search_ItemSearchResults_results_List | SeriesSearchQuery_search_ItemSearchResults_results_ListFacet | SeriesSearchQuery_search_ItemSearchResults_results_ListFolder | SeriesSearchQuery_search_ItemSearchResults_results_ListItem | SeriesSearchQuery_search_ItemSearchResults_results_ListParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_ListStyle | SeriesSearchQuery_search_ItemSearchResults_results_ListStyleItem | SeriesSearchQuery_search_ItemSearchResults_results_ListingHeroBanner | SeriesSearchQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_LiteratureAuthorization | SeriesSearchQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder | SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | SeriesSearchQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | SeriesSearchQuery_search_ItemSearchResults_results_LoadMore | SeriesSearchQuery_search_ItemSearchResults_results_LoadMoreFolder | SeriesSearchQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | SeriesSearchQuery_search_ItemSearchResults_results_LocationFilter | SeriesSearchQuery_search_ItemSearchResults_results_LocationFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | SeriesSearchQuery_search_ItemSearchResults_results_Log | SeriesSearchQuery_search_ItemSearchResults_results_Login | SeriesSearchQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 | SeriesSearchQuery_search_ItemSearchResults_results_LogoTextBlockItem | SeriesSearchQuery_search_ItemSearchResults_results_LogoTextBlocks | SeriesSearchQuery_search_ItemSearchResults_results_LogoTextBlocksFolder | SeriesSearchQuery_search_ItemSearchResults_results_Logout | SeriesSearchQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 | SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter | SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | SeriesSearchQuery_search_ItemSearchResults_results_ManagedRangeItem | SeriesSearchQuery_search_ItemSearchResults_results_Map | SeriesSearchQuery_search_ItemSearchResults_results_MapParameters | SeriesSearchQuery_search_ItemSearchResults_results_MapsFolder | SeriesSearchQuery_search_ItemSearchResults_results_MapsProvider | SeriesSearchQuery_search_ItemSearchResults_results_MediaBlock | SeriesSearchQuery_search_ItemSearchResults_results_MediaBlockFolder | SeriesSearchQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | SeriesSearchQuery_search_ItemSearchResults_results_MediaLinkParameters | SeriesSearchQuery_search_ItemSearchResults_results_MediaVirtualFolder | SeriesSearchQuery_search_ItemSearchResults_results_MegaNavigation | SeriesSearchQuery_search_ItemSearchResults_results_MegaNavigationFolder | SeriesSearchQuery_search_ItemSearchResults_results_MetaBranding | SeriesSearchQuery_search_ItemSearchResults_results_MetaRenderingParameters | SeriesSearchQuery_search_ItemSearchResults_results_MetadataPartialDesign | SeriesSearchQuery_search_ItemSearchResults_results_Model | SeriesSearchQuery_search_ItemSearchResults_results_ModelIterator | SeriesSearchQuery_search_ItemSearchResults_results_MyLocationPOI | SeriesSearchQuery_search_ItemSearchResults_results_Navigation | SeriesSearchQuery_search_ItemSearchResults_results_NavigationCategory | SeriesSearchQuery_search_ItemSearchResults_results_NavigationFilter | SeriesSearchQuery_search_ItemSearchResults_results_NavigationFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_NavigationLink | SeriesSearchQuery_search_ItemSearchResults_results_NavigationSubcategory | SeriesSearchQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | SeriesSearchQuery_search_ItemSearchResults_results_OneTrustSettings | SeriesSearchQuery_search_ItemSearchResults_results_OptimiserConfiguration | SeriesSearchQuery_search_ItemSearchResults_results_OptimiserConfigurationSection | SeriesSearchQuery_search_ItemSearchResults_results_OptimizedFile | SeriesSearchQuery_search_ItemSearchResults_results_OracleCDPSettings | SeriesSearchQuery_search_ItemSearchResults_results_OverlayContent | SeriesSearchQuery_search_ItemSearchResults_results_OverlayFolderTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Ownership | SeriesSearchQuery_search_ItemSearchResults_results_OwnershipFolder | SeriesSearchQuery_search_ItemSearchResults_results_POI | SeriesSearchQuery_search_ItemSearchResults_results_POIFolder | SeriesSearchQuery_search_ItemSearchResults_results_POIType | SeriesSearchQuery_search_ItemSearchResults_results_POIs | SeriesSearchQuery_search_ItemSearchResults_results_PageBranchesFolder | SeriesSearchQuery_search_ItemSearchResults_results_PageContent | SeriesSearchQuery_search_ItemSearchResults_results_PageContentFolder | SeriesSearchQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesign | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | SeriesSearchQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c | SeriesSearchQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | SeriesSearchQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | SeriesSearchQuery_search_ItemSearchResults_results_PageLevelTabs | SeriesSearchQuery_search_ItemSearchResults_results_PageLevelTabsFolder | SeriesSearchQuery_search_ItemSearchResults_results_PageList | SeriesSearchQuery_search_ItemSearchResults_results_PageSelector | SeriesSearchQuery_search_ItemSearchResults_results_PageSelectorConfiguration | SeriesSearchQuery_search_ItemSearchResults_results_PageSelectorFolder | SeriesSearchQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 | SeriesSearchQuery_search_ItemSearchResults_results_PageSize | SeriesSearchQuery_search_ItemSearchResults_results_PageSizeFolder | SeriesSearchQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d | SeriesSearchQuery_search_ItemSearchResults_results_PageTheme | SeriesSearchQuery_search_ItemSearchResults_results_PageThemesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a | SeriesSearchQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f | SeriesSearchQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 | SeriesSearchQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e | SeriesSearchQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | SeriesSearchQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc | SeriesSearchQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf | SeriesSearchQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada | SeriesSearchQuery_search_ItemSearchResults_results_Pagging | SeriesSearchQuery_search_ItemSearchResults_results_Pagination | SeriesSearchQuery_search_ItemSearchResults_results_PaginationFolder | SeriesSearchQuery_search_ItemSearchResults_results_Paragraph | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab | SeriesSearchQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 | SeriesSearchQuery_search_ItemSearchResults_results_PerformanceChartSettings | SeriesSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod | SeriesSearchQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder | SeriesSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | SeriesSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | SeriesSearchQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | SeriesSearchQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 | SeriesSearchQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | SeriesSearchQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Playlist | SeriesSearchQuery_search_ItemSearchResults_results_PlaylistFolder | SeriesSearchQuery_search_ItemSearchResults_results_PlaylistParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Podcast | SeriesSearchQuery_search_ItemSearchResults_results_PodcastFolder | SeriesSearchQuery_search_ItemSearchResults_results_PodcastPage | SeriesSearchQuery_search_ItemSearchResults_results_PodcastPressReleasePage | SeriesSearchQuery_search_ItemSearchResults_results_PoiTypes | SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep | SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | SeriesSearchQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 | SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep | SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | SeriesSearchQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | SeriesSearchQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | SeriesSearchQuery_search_ItemSearchResults_results_Presentation | SeriesSearchQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseContentType | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseFilter | SeriesSearchQuery_search_ItemSearchResults_results_PressReleasePage | SeriesSearchQuery_search_ItemSearchResults_results_PressReleasePlatform | SeriesSearchQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | SeriesSearchQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | SeriesSearchQuery_search_ItemSearchResults_results_PressReleasesGroupFolder | SeriesSearchQuery_search_ItemSearchResults_results_PrivacyWarning | SeriesSearchQuery_search_ItemSearchResults_results_ProjectFolder | SeriesSearchQuery_search_ItemSearchResults_results_Promo | SeriesSearchQuery_search_ItemSearchResults_results_PromoFolder | SeriesSearchQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e | SeriesSearchQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | SeriesSearchQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | SeriesSearchQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 | SeriesSearchQuery_search_ItemSearchResults_results_PromotedContent | SeriesSearchQuery_search_ItemSearchResults_results_PromotedContentFolder | SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingCard | SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingCards | SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingCategory | SeriesSearchQuery_search_ItemSearchResults_results_PropertyListingFolder | SeriesSearchQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 | SeriesSearchQuery_search_ItemSearchResults_results_QuickLinks | SeriesSearchQuery_search_ItemSearchResults_results_QuickLinksFolder | SeriesSearchQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlockItem | SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlocks | SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlocksFolder | SeriesSearchQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Quote | SeriesSearchQuery_search_ItemSearchResults_results_QuoteFolder | SeriesSearchQuery_search_ItemSearchResults_results_QuoteParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_RadiusFilter | SeriesSearchQuery_search_ItemSearchResults_results_RadiusFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | SeriesSearchQuery_search_ItemSearchResults_results_RadiusScheme | SeriesSearchQuery_search_ItemSearchResults_results_RadiusSchemeValue | SeriesSearchQuery_search_ItemSearchResults_results_RangeSliderFilter | SeriesSearchQuery_search_ItemSearchResults_results_RangeSliderFilterFolder | SeriesSearchQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | SeriesSearchQuery_search_ItemSearchResults_results_RecentArticles | SeriesSearchQuery_search_ItemSearchResults_results_Redirect | SeriesSearchQuery_search_ItemSearchResults_results_RedirectMap | SeriesSearchQuery_search_ItemSearchResults_results_RedirectMaps | SeriesSearchQuery_search_ItemSearchResults_results_Region | SeriesSearchQuery_search_ItemSearchResults_results_RegionLanguages | SeriesSearchQuery_search_ItemSearchResults_results_RegionLanguagesFolder | SeriesSearchQuery_search_ItemSearchResults_results_RelatedArticles | SeriesSearchQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_RenderEngineType | SeriesSearchQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | SeriesSearchQuery_search_ItemSearchResults_results_RenderingHost | SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage | SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | SeriesSearchQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | SeriesSearchQuery_search_ItemSearchResults_results_ResponsiveImage | SeriesSearchQuery_search_ItemSearchResults_results_ResultsCount | SeriesSearchQuery_search_ItemSearchResults_results_ResultsCountFolder | SeriesSearchQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | SeriesSearchQuery_search_ItemSearchResults_results_ResultsVariantSelector | SeriesSearchQuery_search_ItemSearchResults_results_RichText | SeriesSearchQuery_search_ItemSearchResults_results_RichTextFolder | SeriesSearchQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce | SeriesSearchQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d | SeriesSearchQuery_search_ItemSearchResults_results_RiskImageMapping | SeriesSearchQuery_search_ItemSearchResults_results_RiskImageMappings | SeriesSearchQuery_search_ItemSearchResults_results_RiskLevelOption | SeriesSearchQuery_search_ItemSearchResults_results_RiskLevelOptionFolder | SeriesSearchQuery_search_ItemSearchResults_results_RiskWarning | SeriesSearchQuery_search_ItemSearchResults_results_RiskWarningFolder | SeriesSearchQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_RolePlaceholder | SeriesSearchQuery_search_ItemSearchResults_results_RowSplitter | SeriesSearchQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 | SeriesSearchQuery_search_ItemSearchResults_results_Rule | SeriesSearchQuery_search_ItemSearchResults_results_SDRLogoMapping | SeriesSearchQuery_search_ItemSearchResults_results_SDRLogoMappings | SeriesSearchQuery_search_ItemSearchResults_results_SDRTypeOption | SeriesSearchQuery_search_ItemSearchResults_results_SDRTypeOptionFolder | SeriesSearchQuery_search_ItemSearchResults_results_SXAJSSLayout | SeriesSearchQuery_search_ItemSearchResults_results_SXARole | SeriesSearchQuery_search_ItemSearchResults_results_SXAStandardValuesFolder | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceAlertMessage | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceCheckBox | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceCheckBoxType | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceDateInput | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceDropdown | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceDropdownOption | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceHiddenField | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceInput | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceInputType | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedForm | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceRichTextArea | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceSection | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceSortCodeInput | SeriesSearchQuery_search_ItemSearchResults_results_SalesforceSubmissionType | SeriesSearchQuery_search_ItemSearchResults_results_Scope | SeriesSearchQuery_search_ItemSearchResults_results_ScopesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Scriban | SeriesSearchQuery_search_ItemSearchResults_results_Scripts | SeriesSearchQuery_search_ItemSearchResults_results_SearchBox | SeriesSearchQuery_search_ItemSearchResults_results_SearchBoxFolder | SeriesSearchQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 | SeriesSearchQuery_search_ItemSearchResults_results_SearchFolder | SeriesSearchQuery_search_ItemSearchResults_results_SearchResults | SeriesSearchQuery_search_ItemSearchResults_results_SearchResultsFolder | SeriesSearchQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | SeriesSearchQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_SectionHeading | SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingFolder | SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingType | SeriesSearchQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder | SeriesSearchQuery_search_ItemSearchResults_results_SectionSelector | SeriesSearchQuery_search_ItemSearchResults_results_SectionSelectorFolder | SeriesSearchQuery_search_ItemSearchResults_results_SectionSelectorTab | SeriesSearchQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 | SeriesSearchQuery_search_ItemSearchResults_results_Series | SeriesSearchQuery_search_ItemSearchResults_results_SeriesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Settings | SeriesSearchQuery_search_ItemSearchResults_results_SettingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e | SeriesSearchQuery_search_ItemSearchResults_results_SharePriceSettings | SeriesSearchQuery_search_ItemSearchResults_results_SharedArticlesFolder | SeriesSearchQuery_search_ItemSearchResults_results_SharedContentFolder | SeriesSearchQuery_search_ItemSearchResults_results_SharedFolder | SeriesSearchQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder | SeriesSearchQuery_search_ItemSearchResults_results_SharedPressReleasesFolder | SeriesSearchQuery_search_ItemSearchResults_results_SharedSettingsFolder | SeriesSearchQuery_search_ItemSearchResults_results_SharedSitesSettings | SeriesSearchQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | SeriesSearchQuery_search_ItemSearchResults_results_Showcase | SeriesSearchQuery_search_ItemSearchResults_results_ShowcaseFolder | SeriesSearchQuery_search_ItemSearchResults_results_ShowcaseItem | SeriesSearchQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Site | SeriesSearchQuery_search_ItemSearchResults_results_SiteContentFolder | SeriesSearchQuery_search_ItemSearchResults_results_SiteDefinition | SeriesSearchQuery_search_ItemSearchResults_results_SiteEntryDisclaimer | SeriesSearchQuery_search_ItemSearchResults_results_SiteFolder | SeriesSearchQuery_search_ItemSearchResults_results_SiteGrouping | SeriesSearchQuery_search_ItemSearchResults_results_SiteManagement | SeriesSearchQuery_search_ItemSearchResults_results_SiteSecurityItemPointer | SeriesSearchQuery_search_ItemSearchResults_results_SiteSelector | SeriesSearchQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | SeriesSearchQuery_search_ItemSearchResults_results_SiteSetupRoot | SeriesSearchQuery_search_ItemSearchResults_results_SiteTheme | SeriesSearchQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c | SeriesSearchQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_SitecoreRole | SeriesSearchQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | SeriesSearchQuery_search_ItemSearchResults_results_SkipLink | SeriesSearchQuery_search_ItemSearchResults_results_SkipLinkParameters | SeriesSearchQuery_search_ItemSearchResults_results_SkipLinksFolder | SeriesSearchQuery_search_ItemSearchResults_results_Snippet | SeriesSearchQuery_search_ItemSearchResults_results_SnippetItem | SeriesSearchQuery_search_ItemSearchResults_results_SnippetsFolder | SeriesSearchQuery_search_ItemSearchResults_results_SocialLoginWrapper | SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaButtons | SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaFolder | SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaShare | SeriesSearchQuery_search_ItemSearchResults_results_SocialMediaTemplate | SeriesSearchQuery_search_ItemSearchResults_results_SocialNetwork | SeriesSearchQuery_search_ItemSearchResults_results_SocialNetworkFolder | SeriesSearchQuery_search_ItemSearchResults_results_SocialNetworkLink | SeriesSearchQuery_search_ItemSearchResults_results_SolutionTemplate | SeriesSearchQuery_search_ItemSearchResults_results_SortResults | SeriesSearchQuery_search_ItemSearchResults_results_SortResultsFolder | SeriesSearchQuery_search_ItemSearchResults_results_Sorting | SeriesSearchQuery_search_ItemSearchResults_results_SortingGroups | SeriesSearchQuery_search_ItemSearchResults_results_SpotifyPodcast | SeriesSearchQuery_search_ItemSearchResults_results_SpotifyPodcastFolder | SeriesSearchQuery_search_ItemSearchResults_results_StickyCTA | SeriesSearchQuery_search_ItemSearchResults_results_StickyCTAFolder | SeriesSearchQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_StrategiesInFocusFolder | SeriesSearchQuery_search_ItemSearchResults_results_StrategyInFocus | SeriesSearchQuery_search_ItemSearchResults_results_Style | SeriesSearchQuery_search_ItemSearchResults_results_Styles | SeriesSearchQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 | SeriesSearchQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Tab | SeriesSearchQuery_search_ItemSearchResults_results_TabItem | SeriesSearchQuery_search_ItemSearchResults_results_TableOfContents | SeriesSearchQuery_search_ItemSearchResults_results_TableOfContentsFolder | SeriesSearchQuery_search_ItemSearchResults_results_TableOfContentsSection | SeriesSearchQuery_search_ItemSearchResults_results_TableOfContentsSubsection | SeriesSearchQuery_search_ItemSearchResults_results_Tabs | SeriesSearchQuery_search_ItemSearchResults_results_TabsFolder | SeriesSearchQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a | SeriesSearchQuery_search_ItemSearchResults_results_Tag | SeriesSearchQuery_search_ItemSearchResults_results_TagCloud | SeriesSearchQuery_search_ItemSearchResults_results_TagFolder | SeriesSearchQuery_search_ItemSearchResults_results_TagList | SeriesSearchQuery_search_ItemSearchResults_results_TeamBiographySettings | SeriesSearchQuery_search_ItemSearchResults_results_TeamListingCards | SeriesSearchQuery_search_ItemSearchResults_results_TeamListingCardsFolder | SeriesSearchQuery_search_ItemSearchResults_results_TeamMember | SeriesSearchQuery_search_ItemSearchResults_results_TeamMemberCard | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembers | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | SeriesSearchQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | SeriesSearchQuery_search_ItemSearchResults_results_TeamProfileCards | SeriesSearchQuery_search_ItemSearchResults_results_TeamProfileCardsFolder | SeriesSearchQuery_search_ItemSearchResults_results_TechzoneArticlePage | SeriesSearchQuery_search_ItemSearchResults_results_Tenant | SeriesSearchQuery_search_ItemSearchResults_results_TenantFolder | SeriesSearchQuery_search_ItemSearchResults_results_TenantSecurityItemPointer | SeriesSearchQuery_search_ItemSearchResults_results_TenantSetupRoot | SeriesSearchQuery_search_ItemSearchResults_results_TertieryHeroBanner | SeriesSearchQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Text | SeriesSearchQuery_search_ItemSearchResults_results_TextBlock | SeriesSearchQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_TextBlockHeadingType | SeriesSearchQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder | SeriesSearchQuery_search_ItemSearchResults_results_TextBlockLinkType | SeriesSearchQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder | SeriesSearchQuery_search_ItemSearchResults_results_TextBlocks | SeriesSearchQuery_search_ItemSearchResults_results_TextBlocksFolder | SeriesSearchQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_TextFolder | SeriesSearchQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 | SeriesSearchQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 | SeriesSearchQuery_search_ItemSearchResults_results_Theme | SeriesSearchQuery_search_ItemSearchResults_results_ThemeTag | SeriesSearchQuery_search_ItemSearchResults_results_ThemeTagsFolder | SeriesSearchQuery_search_ItemSearchResults_results_ThemingMode | SeriesSearchQuery_search_ItemSearchResults_results_ThemingModes | SeriesSearchQuery_search_ItemSearchResults_results_Tile | SeriesSearchQuery_search_ItemSearchResults_results_TileLink | SeriesSearchQuery_search_ItemSearchResults_results_TileParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_TileSizeOption | SeriesSearchQuery_search_ItemSearchResults_results_TileSizeOptionFolder | SeriesSearchQuery_search_ItemSearchResults_results_TilesFolder | SeriesSearchQuery_search_ItemSearchResults_results_TilesParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Title | SeriesSearchQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe | SeriesSearchQuery_search_ItemSearchResults_results_Toggle | SeriesSearchQuery_search_ItemSearchResults_results_ToggleFolder | SeriesSearchQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | SeriesSearchQuery_search_ItemSearchResults_results_Transformation | SeriesSearchQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_TrustFinder | SeriesSearchQuery_search_ItemSearchResults_results_TrustFinderFilterOption | SeriesSearchQuery_search_ItemSearchResults_results_TrustRegion | SeriesSearchQuery_search_ItemSearchResults_results_TrustType | SeriesSearchQuery_search_ItemSearchResults_results_TrustTypesFolder | SeriesSearchQuery_search_ItemSearchResults_results_Twitter | SeriesSearchQuery_search_ItemSearchResults_results_TwitterApp | SeriesSearchQuery_search_ItemSearchResults_results_TwitterApps | SeriesSearchQuery_search_ItemSearchResults_results_TwitterFolder | SeriesSearchQuery_search_ItemSearchResults_results_TwitterParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_TwitterSettings | SeriesSearchQuery_search_ItemSearchResults_results_UnknownItem | SeriesSearchQuery_search_ItemSearchResults_results_UnminifiedFile | SeriesSearchQuery_search_ItemSearchResults_results_UpgradeScript | SeriesSearchQuery_search_ItemSearchResults_results_UpgradeScriptLibrary | SeriesSearchQuery_search_ItemSearchResults_results_VariantComponentField | SeriesSearchQuery_search_ItemSearchResults_results_VariantDateField | SeriesSearchQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | SeriesSearchQuery_search_ItemSearchResults_results_VariantPlaceholder | SeriesSearchQuery_search_ItemSearchResults_results_VariantReference | SeriesSearchQuery_search_ItemSearchResults_results_VariantSection | SeriesSearchQuery_search_ItemSearchResults_results_VariantTemplate | SeriesSearchQuery_search_ItemSearchResults_results_VariantText | SeriesSearchQuery_search_ItemSearchResults_results_VariantToken | SeriesSearchQuery_search_ItemSearchResults_results_Variants | SeriesSearchQuery_search_ItemSearchResults_results_VectorFolder | SeriesSearchQuery_search_ItemSearchResults_results_VectorTile | SeriesSearchQuery_search_ItemSearchResults_results_VectorTileLink | SeriesSearchQuery_search_ItemSearchResults_results_VectorTilesFolder | SeriesSearchQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f | SeriesSearchQuery_search_ItemSearchResults_results_Video | SeriesSearchQuery_search_ItemSearchResults_results_VideoCountOption | SeriesSearchQuery_search_ItemSearchResults_results_VideoCountOptions | SeriesSearchQuery_search_ItemSearchResults_results_VideoFolder | SeriesSearchQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 | SeriesSearchQuery_search_ItemSearchResults_results_VideoPage | SeriesSearchQuery_search_ItemSearchResults_results_VideoParameters | SeriesSearchQuery_search_ItemSearchResults_results_VideoParametersTemplate | SeriesSearchQuery_search_ItemSearchResults_results_VideoPressReleasePage | SeriesSearchQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 | SeriesSearchQuery_search_ItemSearchResults_results__AssetsOptimization | SeriesSearchQuery_search_ItemSearchResults_results__BackgroundImage | SeriesSearchQuery_search_ItemSearchResults_results__CompatibleThemes | SeriesSearchQuery_search_ItemSearchResults_results__CompositeTheme | SeriesSearchQuery_search_ItemSearchResults_results__CustomMetadata | SeriesSearchQuery_search_ItemSearchResults_results__CustomRenderingViewPath | SeriesSearchQuery_search_ItemSearchResults_results__DatasourceBehaviour | SeriesSearchQuery_search_ItemSearchResults_results__Favicon | SeriesSearchQuery_search_ItemSearchResults_results__FormsFolderLocation | SeriesSearchQuery_search_ItemSearchResults_results__FundSettings | SeriesSearchQuery_search_ItemSearchResults_results__HasValidUrlName | SeriesSearchQuery_search_ItemSearchResults_results__LocalDataLink | SeriesSearchQuery_search_ItemSearchResults_results__Login | SeriesSearchQuery_search_ItemSearchResults_results__OpenGraphMetadata | SeriesSearchQuery_search_ItemSearchResults_results__PageDesignTheme | SeriesSearchQuery_search_ItemSearchResults_results__PageSearchScope | SeriesSearchQuery_search_ItemSearchResults_results__SearchCriteria | SeriesSearchQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems | SeriesSearchQuery_search_ItemSearchResults_results__SeoMetadata | SeriesSearchQuery_search_ItemSearchResults_results__SiteTheme | SeriesSearchQuery_search_ItemSearchResults_results__SitemapSettings | SeriesSearchQuery_search_ItemSearchResults_results__StickyNote | SeriesSearchQuery_search_ItemSearchResults_results__Styleable | SeriesSearchQuery_search_ItemSearchResults_results__TwitterMetadata | SeriesSearchQuery_search_ItemSearchResults_results__Webinar | SeriesSearchQuery_search_ItemSearchResults_results__WildcardSource;

export type SeriesSearchQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: SeriesSearchQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<SeriesSearchQuery_search_ItemSearchResults_results>> }
);

export type SeriesSearchQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<SeriesSearchQuery_search_ItemSearchResults> }
);


export type SeriesSearchQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int']['input'];
  pageHash: Types.InputMaybe<Types.Scalars['String']['input']>;
  seriesName: Types.InputMaybe<Types.Scalars['String']['input']>;
  language: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SeriesSearchQuery = SeriesSearchQuery_Query;

export type SeriesSearchBase_Accordion_Fragment = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AccordionFolder_Fragment = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AccordionItem_Fragment = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AccordionParametersTemplate_Fragment = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AccordionPresentation_Fragment = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AccordionPresentationFolder_Fragment = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AddItem_Fragment = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AddItem_De8c75222f3241288f20342f479894eb_Fragment = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AddThisParameters_Fragment = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AggregatedFacetFilter_Fragment = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AlertMessage_Fragment = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AlertMessageFolder_Fragment = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AlertMessageParametersTemplate_Fragment = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AlertMessageType_Fragment = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AllertMessageTypeFolder_Fragment = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Archive_Fragment = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleAuthor_Fragment = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleAuthorsFolder_Fragment = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleCategoriesFolder_Fragment = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleCategory_Fragment = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleChapter_Fragment = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleChapters_Fragment = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleContentType_Fragment = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleContentTypesFolder_Fragment = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleFilter_Fragment = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleFilterOption_Fragment = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleFootnote_Fragment = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleFootnoteLink_Fragment = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleFootnoteText_Fragment = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleInfogramTile_Fragment = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleInfogramTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticlePage_Fragment = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleRegion_Fragment = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleRegionsFolder_Fragment = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSearchPage_Fragment = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSeriesCollection_Fragment = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSeriesFolder_Fragment = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSettings_Fragment = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSubscriptionBanner_Fragment = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleSubscriptionBannerFolder_Fragment = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleTag_Fragment = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleTagsFolder_Fragment = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleTeamAuthor_Fragment = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleTilesParametersTemplate_Fragment = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ArticlesGroupFolder_Fragment = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AttachThemeExtension_Fragment = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AutomaticDocumentListings_Fragment = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AutomaticDocumentListingsFolder_Fragment = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AvailableJsonRenderings_Fragment = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AvailableMetaRenderings_Fragment = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AvailableRenderings_Fragment = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AwardsBanner_Fragment = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AwardsBannerFolder_Fragment = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AwardsBannerImage_Fragment = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_AwardsBannerParametersTemplate_Fragment = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ByocWrapperRenderingParameters_Fragment = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BackgroundColorOption_Fragment = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BackgroundColorOptionFolder_Fragment = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BannerFolder_Fragment = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BannerType_Fragment = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BannerTypeFolder_Fragment = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BaseHeading_Fragment = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BaseHeadingFolder_Fragment = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BoolFacet_Fragment = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BranchesFolder_Fragment = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Breadcrumb_Fragment = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_BrowserTitleDefinition_Fragment = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CorsEntry_Fragment = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CorsGrouping_Fragment = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CtaPresentationType_Fragment = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CtaPresentationTypeFolder_Fragment = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__AbrdnPage_Fragment = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ActionBase_Fragment = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__AdvancedParameter_Fragment = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__App_Fragment = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ArticleWildcardPage_Fragment = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__AvailableRenderingsFolder_Fragment = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ByocRenderingParameters_Fragment = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BackgroundParametersTemplate_Fragment = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BaseCta_Fragment = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_Fragment = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BaseRenderingParameters_Fragment = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BaseTheme_Fragment = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__BaseVariantField_Fragment = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__Class_Fragment = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__CompositeGroup_Fragment = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__CompositeSection_Fragment = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__EloquaForm_Fragment = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ExtendedOptions_Fragment = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__FEaaSRenderingParameters_Fragment = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__FacetSelectorConfigBase_Fragment = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__GlobalDatasourceBehavior_Fragment = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__GridDefinition_Fragment = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__GridItemBase_Fragment = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__GridParameters_Fragment = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__HeadlessSite_Fragment = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__HeadlessTenant_Fragment = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IAllowEmpty_Fragment = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IBaseVariantDefinition_Fragment = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IBoosting_Fragment = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ICacheable_Fragment = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ICompatibleRenderings_Fragment = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IComponentVariant_Fragment = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IControlType_Fragment = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IDynamicPlaceholder_Fragment = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IfEaaSComponentsDataSourceTemplates_Fragment = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IfEaaSComponentsEditorScriptUrl_Fragment = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IIcon_Fragment = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ILocation_Fragment = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IPaginable_Fragment = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IPagination_Fragment = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IPoi_Fragment = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IRenderingId_Fragment = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ISplitter_Fragment = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IStyling_Fragment = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__IVariantDefinition_Fragment = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__InvestmentTrustPage_Fragment = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__JsonField_Fragment = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__JsonReference_Fragment = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__JssData_Fragment = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__JssSettings_Fragment = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__JssSiteFolder_Fragment = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__JssRootFolder_Fragment = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__Page_Fragment = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PageData_Fragment = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PageDesignFolder_Fragment = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PartialDesign_Fragment = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PartialDesignFolder_Fragment = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PlaceholderWrapper_Fragment = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__RedirectMapGrouping_Fragment = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__Route_Fragment = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__SimpleVideo_Fragment = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__SiteSettingsFolder_Fragment = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__SitemapSettings_Fragment = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__StandardTemplate_Fragment = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__TrustFolder_Fragment = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__VariantDefinition_Fragment = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__VariantField_Fragment = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C__VariantsGrouping_Fragment = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___AdvancedItem_Fragment = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Arguments_Fragment = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Article_Fragment = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ArticlePageWorkflow_Fragment = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ArticleSearchPage_Fragment = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ArticleWildcard_Fragment = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___AssetServiceThemeMode_Fragment = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseArticle_Fragment = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseDataFolder_Fragment = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseHelpArticle_Fragment = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseInvestmentTrust_Fragment = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseJssTenant_Fragment = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePage_Fragment = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePageDesign_Fragment = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePageDesignFolder_Fragment = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePartialDesign_Fragment = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePartialDesignFolder_Fragment = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePlaceholder_Fragment = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePlaceholderSettingsFolder_Fragment = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePresentation_Fragment = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BasePressRelease_Fragment = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseRenderingParameters_Fragment = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseSxaStandardValuesFolder_Fragment = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseSettings_Fragment = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseSharedSitesSettings_Fragment = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseSiteDefinition_Fragment = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseSiteFolder_Fragment = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseSiteGrouping_Fragment = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseSiteRoot_Fragment = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseTenant_Fragment = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BaseTenantFolder_Fragment = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___BucketRules_Fragment = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Cors_Fragment = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Content_Fragment = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ContentType_Fragment = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___DataAttributes_Fragment = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___DatasourceWorkflow_Fragment = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Dependencies_Fragment = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Description_Fragment = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___DesignTemplateMapping_Fragment = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Designable_Fragment = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___EditType_Fragment = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___EditingTheme_Fragment = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Enabled_Fragment = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ErrorHandling_Fragment = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ExternalArticle_Fragment = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Fields_Fragment = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FilteredArticlesParent_Fragment = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FilteredArticlesWildcard_Fragment = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Footnotes_Fragment = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundDetailsWildcard_Fragment = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundFormAvailability_Fragment = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundMetadataPage_Fragment = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundSearchPage_Fragment = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundsFolder_Fragment = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundsFormsFolder_Fragment = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundsLiteratureFolder_Fragment = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___FundsShareclassesDetailsWildcard_Fragment = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___GridMapping_Fragment = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___HelpArticle_Fragment = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___HelpArticleSearchPage_Fragment = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___HelpArticleWildcard_Fragment = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___HorizonDatasourceGrouping_Fragment = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Icon_Fragment = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___IncludeByDefault_Fragment = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___IncludeIfInstalled_Fragment = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___InternalArticle_Fragment = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___InternetExplorerCompatibilityMode_Fragment = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___IsSystemModule_Fragment = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___JsonVariantPaging_Fragment = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___JsonVariantsBase_Fragment = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___LimitedDisplay_Fragment = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___LinkAttributes_Fragment = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___LinkSettings_Fragment = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___LiteratureHubSearchPage_Fragment = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ManualKeyInformation_Fragment = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___MemberOf_Fragment = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___MetadataPage_Fragment = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Modules_Fragment = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Name_Fragment = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Name_299cdb154745448a807868d401248eaa_Fragment = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Name_B88cf88159a54a19991e71038751cb60_Fragment = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Navigable_Fragment = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___NavigablePage_Fragment = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PageContent_Fragment = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PageWorkflow_Fragment = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PerSiteStandardValues_Fragment = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Podcast_Fragment = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PodcastPressRelease_Fragment = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PremiumContentPage_Fragment = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PressRelease_Fragment = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PressReleaseContentType_Fragment = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PressReleaseSearchPage_Fragment = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PressReleaseWildcard_Fragment = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___ProtectedTheme_Fragment = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___PublishingGroupingTemplate_Fragment = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___RenderingRelatedParameters_Fragment = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___RenderingVariantsBase_Fragment = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___RenderingsList_Fragment = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___RobotsContent_Fragment = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___RoleDomain_Fragment = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___RoleName_Fragment = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___RoleType_Fragment = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SalesforceCommonValidations_Fragment = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SalesforceFieldId_Fragment = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SalesforceFieldTitle_Fragment = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SalesforceFieldValue_Fragment = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Script_Fragment = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SearchSignature_Fragment = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Searchable_Fragment = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SecurityItemPointer_Fragment = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SharedArticles_Fragment = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SharedContent_Fragment = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SharedHelpArticles_Fragment = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SharedPage_Fragment = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SharedPressReleases_Fragment = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SharedRoot_Fragment = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SharedSettings_Fragment = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SiteContent_Fragment = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SiteFolder_Fragment = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SiteMediaLibrary_Fragment = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SiteSettings_Fragment = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SiteTemplate_Fragment = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SitecoreClientSiteManaging_Fragment = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Sitemap_Fragment = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SitemapMediaItems_Fragment = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SlidersRangeSettings_Fragment = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SolutionTemplateContent_Fragment = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SolutionTemplateDescription_Fragment = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SolutionTemplateName_Fragment = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SortOrder_Fragment = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___StackBreakpoint_Fragment = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Statistics_Fragment = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___SupportedLanguages_Fragment = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Taggable_Fragment = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___TeamMembersParentPage_Fragment = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___TeamMembersWildcard_Fragment = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___TechzoneArticle_Fragment = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Template_Fragment = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Title_Fragment = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Type_Fragment = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Validation_Fragment = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___VariantPaging_Fragment = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___VectorTile_Fragment = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___VectorTileLink_Fragment = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Video_Fragment = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___VideoPressRelease_Fragment = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___Width_Fragment = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_C___WildcardPage_Fragment = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CacheSetting_Fragment = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CalendarEvent_Fragment = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CallOutSection_Fragment = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CallOutSectionDropdownOption_Fragment = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CallOutSectionFolder_Fragment = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CallOutSectionParametersTemplate_Fragment = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CallToAction_Fragment = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CallToActionFolder_Fragment = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CapabilitiesFolder_Fragment = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Capability_Fragment = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CapabilityMap_Fragment = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CapabilityMappings_Fragment = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Carousel_Fragment = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CarouselFolder_Fragment = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CarouselSlide_Fragment = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Checkbox_Fragment = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ChecklistFilter_Fragment = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ChecklistFilterFolder_Fragment = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ColumnSplitter_Fragment = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CompatibilityMode_Fragment = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ComponentConfiguration_Fragment = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ComponentThemeConfiguration_Fragment = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ComponentThemesConfiguration_Fragment = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ComponentsConfigurations_Fragment = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ConfigurationFolder_Fragment = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Container_Fragment = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContainerOption_Fragment = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContainerOptionsFolder_Fragment = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContainerParametersTemplate_Fragment = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContentBlock_Fragment = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContentBlockFolder_Fragment = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContentToken_Fragment = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContentTokenFolder_Fragment = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ContentType_Fragment = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CorporateTheme_Fragment = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CorporateThemesFolder_Fragment = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Country_Fragment = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CountryIsoCode_Fragment = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CountryIsoCodesFolder_Fragment = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CustomerReviewFolder_Fragment = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CustomerReviewTile_Fragment = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_CustomerReviewTileParametersTemplate_Fragment = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DataBridgeDocumentCategoryMap_Fragment = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DataBridgeFund_Fragment = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DataBridgeFundRangeName_Fragment = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DataBridgeSettingsFolder_Fragment = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DataBridgeShareClass_Fragment = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DataFolder_Fragment = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DatasourceConfiguration_Fragment = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DatasourceConfigurations_Fragment = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DatasourceWorkflowAction_Fragment = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DateFacet_Fragment = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DateFilter_Fragment = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DateFilterFolder_Fragment = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DefaultColumnLayout_Fragment = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DefaultShareclassMapping_Fragment = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DefaultShareclassMappings_Fragment = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DescriptiveHighlight_Fragment = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DescriptiveHighlightFolder_Fragment = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DescriptiveHighlightItem_Fragment = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DescriptiveHighlightParametersTemplate_Fragment = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Device_Fragment = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Devices_Fragment = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DictionaryFolder_Fragment = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DisqusParameters_Fragment = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DistanceFacet_Fragment = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Divider_Fragment = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DocumentItem_Fragment = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DocumentListings_Fragment = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DocumentListingsFolder_Fragment = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DocumentTypeFolder_Fragment = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DominantLanguageMapping_Fragment = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Dropdown_Fragment = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DropdownFilter_Fragment = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DropdownFilterFolder_Fragment = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditEditingTheme_Fragment = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditFrame_Fragment = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditModePanel_Fragment = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditSiteItem_Fragment = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditSiteTheme_Fragment = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditTenantTemplate_Fragment = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EditType_Fragment = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EloquaFormFolder_Fragment = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EloquaFundForm_Fragment = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Enum_Fragment = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Enums_Fragment = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ErrorPage_Fragment = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EventCalendarParameters_Fragment = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EventList_Fragment = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EventListParameters_Fragment = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EventTypes_Fragment = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_EventsFolder_Fragment = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExecuteScript_Fragment = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExtendSiteTheme_Fragment = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ExternalLiterature_Fragment = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FEaaSWrapperRenderingParameters_Fragment = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacebookCommentsParametersTemplate_Fragment = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacetSlider_Fragment = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacetSliderFolder_Fragment = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacetSummary_Fragment = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacetSummaryFolder_Fragment = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FacetsGrouping_Fragment = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FakeNavigationItem_Fragment = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeatureBanner_Fragment = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeatureBannerParametersTemplate_Fragment = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeaturedArticles_Fragment = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeaturedArticlesFolder_Fragment = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeaturedTheme_Fragment = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeaturedThemesFolder_Fragment = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Feed_Fragment = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeedFolder_Fragment = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FeedParameters_Fragment = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FieldEditor_Fragment = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FieldRenderer_Fragment = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FileList_Fragment = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FileListFolder_Fragment = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FileListParametersTemplate_Fragment = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_File_04129321770849c1801baee196e1c0a8_Fragment = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilterCriteria_Fragment = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilterCriteriaFolder_Fragment = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilterTaxonomyOption_Fragment = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilterTaxonomyOptions_Fragment = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesParentPage_Fragment = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesWildcardPage_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Flip_Fragment = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FlipFolder_Fragment = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Flip_5ef078504c044b839dafefd752cfaba8_Fragment = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Flipside_Fragment = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FloatFacet_Fragment = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Footer_Fragment = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FooterFolder_Fragment = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FooterLink_Fragment = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FormRenderingParameters_Fragment = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundAssetClass_Fragment = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundAssetClassesFolder_Fragment = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundDetailsWildcardPage_Fragment = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundFormsFolder_Fragment = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundInFocus_Fragment = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundInFocusShareClass_Fragment = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSearchPage_Fragment = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSettings_Fragment = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundShareclassDetailsWildcardPage_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSubAssetClass_Fragment = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundSubAssetClassesFolder_Fragment = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundsExternalLiteratureFolder_Fragment = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundsFolder_Fragment = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundsInFocusFolder_Fragment = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundsInFocusParametersTemplate_Fragment = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundsLiteratureFolder_Fragment = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_FundsLiteratureMappingsFolder_Fragment = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Gallery_Fragment = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GalleryFolder_Fragment = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GalleryImage_Fragment = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GalleryParametersTemplate_Fragment = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GalleryVideo_Fragment = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GatedAccordionContainer_Fragment = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GlobalLanguageSelector_Fragment = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GlobalNavigationBar_Fragment = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GoogleAnalytics_Fragment = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GoogleTagManager_Fragment = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GoogleTagManagerFolder_Fragment = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GridSetup_Fragment = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_GridTheme_Fragment = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HtmlCode_Fragment = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HtmlCodeFolder_Fragment = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HtmlInclude_Fragment = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HtmlIncludesFolder_Fragment = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HtmlSnippet_Fragment = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HtmlSnippetFolder_Fragment = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HtmlTag_Fragment = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Header_Fragment = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeaderFolder_Fragment = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Heading_Fragment = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSiteSetupRoot_Fragment = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessSolutionTemplateFolder_Fragment = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenantSetupRoot_Fragment = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessTrustSite_Fragment = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessVariants_Fragment = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeadlessVariantsGrouping_Fragment = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticlePage_Fragment = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticlePlatform_Fragment = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticlePlatformMap_Fragment = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticlePlatformMappings_Fragment = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticlePlatformsFolder_Fragment = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticleSearchPage_Fragment = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticleTag_Fragment = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticleTagsFolder_Fragment = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticleWildcardPage_Fragment = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpArticlesGroupFolder_Fragment = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpTagMap_Fragment = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HelpTagMappings_Fragment = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HeroBanner_Fragment = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Highlight_Fragment = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HighlightBlock_Fragment = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HighlightBlockFolder_Fragment = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HighlightBlockParametersTemplate_Fragment = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HighlightFolder_Fragment = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HighlightItem_Fragment = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HighlightParametersTemplate_Fragment = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Home_Fragment = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HomePage_Fragment = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HomePage_0d3963a8171d4080b5f808618578b631_Fragment = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HomePage_Cde13c51062d426b95569e8202edc963_Fragment = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IFrame_Fragment = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IFrameFolder_Fragment = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IFrameParametersTemplate_Fragment = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Icon_Fragment = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IconFolder_Fragment = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Image_Fragment = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ImageFolder_Fragment = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ImageParametersTemplate_Fragment = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Image_83bc563c6320490092f8204bff81586a_Fragment = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Image_15185b0e641844499f934ff03b7ee032_Fragment = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Image_D885df8cb2d64007b34b2bbafb527304_Fragment = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Infographics_Fragment = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InfographicsFolder_Fragment = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InputValidationStep_Fragment = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IntegerFacet_Fragment = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IntroCopy_Fragment = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_IntroCopyFolder_Fragment = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustAssetClass_Fragment = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustAssetClassFolder_Fragment = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustRegion_Fragment = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustRegionFolder_Fragment = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustStyle_Fragment = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestmentTrustStyleFolder_Fragment = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestorType_Fragment = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_InvestorTypesFolder_Fragment = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ItemQueriesFolder_Fragment = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ItemRights_Fragment = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsBeaconSettings_Fragment = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonCheckbox_Fragment = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonContent_Fragment = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonDate_Fragment = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonFile_Fragment = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonImage_Fragment = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonLayout_Fragment = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonList_Fragment = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonMultilistReference_Fragment = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonPlaceholder_Fragment = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonQuery_Fragment = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonResults_Fragment = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonRichText_Fragment = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonScriban_Fragment = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonSection_Fragment = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonTemplate_Fragment = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonText_Fragment = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonToken_Fragment = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonVariantDefinition_Fragment = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonVariants_Fragment = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssLayout_Fragment = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssSiteGrouping_Fragment = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JssTenantFolder_Fragment = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JavaScriptRendering_Fragment = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JsonRendering_Fragment = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JurisdictionStatus_Fragment = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_JurisdictionsFolder_Fragment = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_KeyHighlightItem_Fragment = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_KeyHighlights_Fragment = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_KeyHighlightsFolder_Fragment = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_KeyHighlightsParametersTemplate_Fragment = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Language_Fragment = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LanguageSelector_Fragment = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LanguagesFolder_Fragment = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LatestPressReleasesParametersTemplate_Fragment = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LayoutServiceVariants_Fragment = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LimitedDisplayFolder_Fragment = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LimitedDisplayOption_Fragment = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Link_Fragment = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LinkList_Fragment = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LinkListFolder_Fragment = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LinksFolder_Fragment = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_List_Fragment = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListFacet_Fragment = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListFolder_Fragment = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListItem_Fragment = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListParametersTemplate_Fragment = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListStyle_Fragment = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListStyleItem_Fragment = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListingHeroBanner_Fragment = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ListingHeroParametersTemplate_Fragment = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LiteratureAuthorization_Fragment = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LiteratureAuthorizationsFolder_Fragment = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LiteratureHubSearchPage_Fragment = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LoadMore_Fragment = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LoadMoreFolder_Fragment = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LocationFilter_Fragment = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LocationFilterFolder_Fragment = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Log_Fragment = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Login_Fragment = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LogoTextBlockItem_Fragment = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LogoTextBlocks_Fragment = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_LogoTextBlocksFolder_Fragment = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Logout_Fragment = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ManagedRangeFilter_Fragment = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ManagedRangeFilterFolder_Fragment = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ManagedRangeItem_Fragment = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Map_Fragment = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MapParameters_Fragment = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MapsFolder_Fragment = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MapsProvider_Fragment = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MediaBlock_Fragment = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MediaBlockFolder_Fragment = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MediaBlockParametersTemplate_Fragment = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MediaLinkParameters_Fragment = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MediaVirtualFolder_Fragment = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MegaNavigation_Fragment = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MegaNavigationFolder_Fragment = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MetaBranding_Fragment = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MetaRenderingParameters_Fragment = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MetadataPartialDesign_Fragment = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Model_Fragment = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ModelIterator_Fragment = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_MyLocationPoi_Fragment = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Navigation_Fragment = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_NavigationCategory_Fragment = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_NavigationFilter_Fragment = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_NavigationFilterFolder_Fragment = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_NavigationLink_Fragment = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_NavigationSubcategory_Fragment = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OneTrustSettings_Fragment = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OptimiserConfiguration_Fragment = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OptimiserConfigurationSection_Fragment = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OptimizedFile_Fragment = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OracleCdpSettings_Fragment = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OverlayContent_Fragment = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OverlayFolderTemplate_Fragment = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Ownership_Fragment = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_OwnershipFolder_Fragment = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Poi_Fragment = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PoiFolder_Fragment = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PoiType_Fragment = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PoIs_Fragment = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageBranchesFolder_Fragment = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageContent_Fragment = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageContentFolder_Fragment = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesign_Fragment = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_Fragment = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageLevelTabs_Fragment = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageLevelTabsFolder_Fragment = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageList_Fragment = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageSelector_Fragment = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageSelectorConfiguration_Fragment = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageSelectorFolder_Fragment = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageSize_Fragment = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageSizeFolder_Fragment = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageTheme_Fragment = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PageThemesFolder_Fragment = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_4f49a81db3664f198b89cab92f377d7a_Fragment = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_5e66d86353544fe6a27d3b894984d50f_Fragment = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_718df200be51463d93edf4d77ab7a49e_Fragment = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Page_Fa608b3e6aeb426388a059d89caabada_Fragment = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Pagging_Fragment = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Pagination_Fragment = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PaginationFolder_Fragment = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Paragraph_Fragment = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_Fragment = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PerformanceChartSettings_Fragment = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PerformanceChartTimePeriod_Fragment = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PerformanceChartTimePeriodFolder_Fragment = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PlainHtmlParametersTemplate_Fragment = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PlaylistFolder_Fragment = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PlaylistParametersTemplate_Fragment = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PodcastFolder_Fragment = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PodcastPage_Fragment = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PodcastPressReleasePage_Fragment = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PoiTypes_Fragment = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostDeleteStep_Fragment = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostSetupStep_Fragment = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteStep_Fragment = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteValidationStep_Fragment = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Presentation_Fragment = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseContentType_Fragment = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseContentTypesFolder_Fragment = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseFilter_Fragment = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleasePage_Fragment = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleasePlatform_Fragment = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleasePlatformsFolder_Fragment = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseSearchPage_Fragment = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseWildcardPage_Fragment = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PressReleasesGroupFolder_Fragment = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PrivacyWarning_Fragment = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ProjectFolder_Fragment = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Promo_Fragment = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PromoFolder_Fragment = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PromotedContent_Fragment = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PromotedContentFolder_Fragment = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PropertyListingCard_Fragment = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PropertyListingCards_Fragment = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PropertyListingCategory_Fragment = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_PropertyListingFolder_Fragment = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Query_98b413525a4b4067b92418a4b50f0a53_Fragment = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuickLinks_Fragment = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuickLinksFolder_Fragment = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuickLinksParametersTemplate_Fragment = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuotationBlockItem_Fragment = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuotationBlocks_Fragment = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuotationBlocksFolder_Fragment = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuotationBlocksParametersTemplate_Fragment = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Quote_Fragment = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuoteFolder_Fragment = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_QuoteParametersTemplate_Fragment = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RadiusFilter_Fragment = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RadiusFilterFolder_Fragment = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RadiusScheme_Fragment = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RadiusSchemeValue_Fragment = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RangeSliderFilter_Fragment = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RangeSliderFilterFolder_Fragment = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RecentArticles_Fragment = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Redirect_Fragment = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RedirectMap_Fragment = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RedirectMaps_Fragment = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Region_Fragment = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RegionLanguages_Fragment = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RegionLanguagesFolder_Fragment = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RelatedArticles_Fragment = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RelatedArticlesParametersTemplate_Fragment = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RenderEngineType_Fragment = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RenderingHost_Fragment = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResizableIFramePage_Fragment = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResponsiveImage_Fragment = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResultsCount_Fragment = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResultsCountFolder_Fragment = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ResultsVariantSelector_Fragment = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RichText_Fragment = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RichTextFolder_Fragment = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RiskImageMapping_Fragment = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RiskImageMappings_Fragment = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RiskLevelOption_Fragment = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RiskLevelOptionFolder_Fragment = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RiskWarning_Fragment = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RiskWarningFolder_Fragment = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RiskWarningParametersTemplate_Fragment = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RolePlaceholder_Fragment = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RowSplitter_Fragment = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Rule_Fragment = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SdrLogoMapping_Fragment = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SdrLogoMappings_Fragment = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SdrTypeOption_Fragment = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SdrTypeOptionFolder_Fragment = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SxajssLayout_Fragment = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SxaRole_Fragment = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SxaStandardValuesFolder_Fragment = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceAlertMessage_Fragment = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceCheckBox_Fragment = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceCheckBoxType_Fragment = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceConditionalRadioButton_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceConditionalRadioButtons_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceDateInput_Fragment = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceDropdown_Fragment = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceDropdownOption_Fragment = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceHiddenField_Fragment = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceInput_Fragment = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceInputType_Fragment = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceIntegratedForm_Fragment = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceIntegratedFormTypesFolder_Fragment = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceRepeatableSubSection_Fragment = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceRichTextArea_Fragment = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceSection_Fragment = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceSortCodeInput_Fragment = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SalesforceSubmissionType_Fragment = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Scope_Fragment = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ScopesFolder_Fragment = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Scriban_Fragment = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Scripts_Fragment = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SearchBox_Fragment = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SearchBoxFolder_Fragment = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SearchFolder_Fragment = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SearchResults_Fragment = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SearchResultsFolder_Fragment = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SecondaryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionHeading_Fragment = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionHeadingFolder_Fragment = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionHeadingParametersTemplate_Fragment = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionHeadingType_Fragment = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionHeadingTypeFolder_Fragment = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionSelector_Fragment = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionSelectorFolder_Fragment = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SectionSelectorTab_Fragment = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Series_Fragment = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SeriesFolder_Fragment = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Settings_Fragment = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SettingsFolder_Fragment = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Settings_6c82caca67dc464195698faad083230e_Fragment = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharePriceSettings_Fragment = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedArticlesFolder_Fragment = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedContentFolder_Fragment = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedFolder_Fragment = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedHelpArticlesFolder_Fragment = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedPressReleasesFolder_Fragment = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedSettingsFolder_Fragment = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedSitesSettings_Fragment = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Showcase_Fragment = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ShowcaseFolder_Fragment = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ShowcaseItem_Fragment = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ShowcaseParametersTemplate_Fragment = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Site_Fragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteContentFolder_Fragment = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteDefinition_Fragment = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteEntryDisclaimer_Fragment = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteFolder_Fragment = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteGrouping_Fragment = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteManagement_Fragment = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteSecurityItemPointer_Fragment = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteSelector_Fragment = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteSetupRoot_Fragment = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SiteTheme_Fragment = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SitecoreFormWrapperParametersTemplate_Fragment = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SitecoreRole_Fragment = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SkipLink_Fragment = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SkipLinkParameters_Fragment = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SkipLinksFolder_Fragment = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Snippet_Fragment = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SnippetItem_Fragment = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SnippetsFolder_Fragment = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialLoginWrapper_Fragment = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialMediaButtons_Fragment = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialMediaFolder_Fragment = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialMediaShare_Fragment = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialMediaTemplate_Fragment = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialNetwork_Fragment = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialNetworkFolder_Fragment = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SocialNetworkLink_Fragment = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SolutionTemplate_Fragment = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SortResults_Fragment = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SortResultsFolder_Fragment = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Sorting_Fragment = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SortingGroups_Fragment = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SpotifyPodcast_Fragment = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SpotifyPodcastFolder_Fragment = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_StickyCta_Fragment = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_StickyCtaFolder_Fragment = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_StickyCtaParametersTemplate_Fragment = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_StrategiesInFocusFolder_Fragment = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_StrategyInFocus_Fragment = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Style_Fragment = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Styles_Fragment = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_SubscriptionBannerParametersTemplate_Fragment = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Tab_Fragment = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TabItem_Fragment = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TableOfContents_Fragment = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TableOfContentsFolder_Fragment = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TableOfContentsSection_Fragment = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TableOfContentsSubsection_Fragment = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Tabs_Fragment = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TabsFolder_Fragment = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Tag_Fragment = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TagCloud_Fragment = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TagFolder_Fragment = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TagList_Fragment = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamBiographySettings_Fragment = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamListingCards_Fragment = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamListingCardsFolder_Fragment = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMember_Fragment = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMemberCard_Fragment = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembers_Fragment = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersParentPage_Fragment = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersWildcardPage_Fragment = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamProfileCards_Fragment = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TeamProfileCardsFolder_Fragment = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TechzoneArticlePage_Fragment = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Tenant_Fragment = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TenantFolder_Fragment = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TenantSecurityItemPointer_Fragment = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TenantSetupRoot_Fragment = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TertieryHeroBanner_Fragment = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TertieryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Text_Fragment = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlock_Fragment = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlockHeadingParametersTemplate_Fragment = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlockHeadingType_Fragment = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlockHeadingTypeFolder_Fragment = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlockLinkType_Fragment = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlockLinkTypeFolder_Fragment = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlocks_Fragment = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlocksFolder_Fragment = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextBlocksParametersTemplate_Fragment = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextFolder_Fragment = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TextFolder_B762d56787f5493cbb480c455d834457_Fragment = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Theme_Fragment = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ThemeTag_Fragment = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ThemeTagsFolder_Fragment = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ThemingMode_Fragment = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ThemingModes_Fragment = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Tile_Fragment = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TileLink_Fragment = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TileParametersTemplate_Fragment = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TileSizeOption_Fragment = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TileSizeOptionFolder_Fragment = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TilesFolder_Fragment = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TilesParametersTemplate_Fragment = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Title_Fragment = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Title_A82e893105754175917de904ef7e6dbe_Fragment = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Toggle_Fragment = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_ToggleFolder_Fragment = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Transformation_Fragment = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TrustArticleHeroParametersTemplate_Fragment = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TrustFinder_Fragment = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TrustFinderFilterOption_Fragment = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TrustRegion_Fragment = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TrustType_Fragment = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TrustTypesFolder_Fragment = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Twitter_Fragment = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TwitterApp_Fragment = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TwitterApps_Fragment = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TwitterFolder_Fragment = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TwitterParametersTemplate_Fragment = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_TwitterSettings_Fragment = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_UnknownItem_Fragment = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_UnminifiedFile_Fragment = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_UpgradeScript_Fragment = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_UpgradeScriptLibrary_Fragment = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantComponentField_Fragment = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantDateField_Fragment = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantPlaceholder_Fragment = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantReference_Fragment = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantSection_Fragment = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantTemplate_Fragment = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantText_Fragment = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VariantToken_Fragment = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Variants_Fragment = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VectorFolder_Fragment = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VectorTile_Fragment = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VectorTileLink_Fragment = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VectorTilesFolder_Fragment = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VectorTilesParametersTemplate_Fragment = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Video_Fragment = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoCountOption_Fragment = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoCountOptions_Fragment = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoFolder_Fragment = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoPage_Fragment = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoParameters_Fragment = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoParametersTemplate_Fragment = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_VideoPressReleasePage_Fragment = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase_Video_4bc649610a894242be2dc5026090cf49_Fragment = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__AssetsOptimization_Fragment = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__BackgroundImage_Fragment = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__CompatibleThemes_Fragment = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__CompositeTheme_Fragment = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__CustomMetadata_Fragment = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__CustomRenderingViewPath_Fragment = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__DatasourceBehaviour_Fragment = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__Favicon_Fragment = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__FormsFolderLocation_Fragment = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__FundSettings_Fragment = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__HasValidUrlName_Fragment = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__LocalDataLink_Fragment = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__Login_Fragment = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__OpenGraphMetadata_Fragment = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__PageDesignTheme_Fragment = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__PageSearchScope_Fragment = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__SearchCriteria_Fragment = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__SearchableWithoutRelatedItems_Fragment = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__SeoMetadata_Fragment = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__SiteTheme_Fragment = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__SitemapSettings_Fragment = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__StickyNote_Fragment = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__Styleable_Fragment = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__TwitterMetadata_Fragment = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__Webinar_Fragment = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBase__WildcardSource_Fragment = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
  & { template: SeriesSearchQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type SeriesSearchBaseFragment = SeriesSearchBase_Accordion_Fragment | SeriesSearchBase_AccordionFolder_Fragment | SeriesSearchBase_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment | SeriesSearchBase_AccordionItem_Fragment | SeriesSearchBase_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment | SeriesSearchBase_AccordionParametersTemplate_Fragment | SeriesSearchBase_AccordionPresentation_Fragment | SeriesSearchBase_AccordionPresentationFolder_Fragment | SeriesSearchBase_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment | SeriesSearchBase_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment | SeriesSearchBase_AddItem_Fragment | SeriesSearchBase_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment | SeriesSearchBase_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment | SeriesSearchBase_AddItem_De8c75222f3241288f20342f479894eb_Fragment | SeriesSearchBase_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment | SeriesSearchBase_AddThisParameters_Fragment | SeriesSearchBase_AggregatedFacetFilter_Fragment | SeriesSearchBase_AlertMessage_Fragment | SeriesSearchBase_AlertMessageFolder_Fragment | SeriesSearchBase_AlertMessageParametersTemplate_Fragment | SeriesSearchBase_AlertMessageType_Fragment | SeriesSearchBase_AllertMessageTypeFolder_Fragment | SeriesSearchBase_Archive_Fragment | SeriesSearchBase_ArticleAuthor_Fragment | SeriesSearchBase_ArticleAuthorsFolder_Fragment | SeriesSearchBase_ArticleCategoriesFolder_Fragment | SeriesSearchBase_ArticleCategory_Fragment | SeriesSearchBase_ArticleChapter_Fragment | SeriesSearchBase_ArticleChapters_Fragment | SeriesSearchBase_ArticleContentType_Fragment | SeriesSearchBase_ArticleContentTypesFolder_Fragment | SeriesSearchBase_ArticleFilter_Fragment | SeriesSearchBase_ArticleFilterOption_Fragment | SeriesSearchBase_ArticleFootnote_Fragment | SeriesSearchBase_ArticleFootnoteLink_Fragment | SeriesSearchBase_ArticleFootnoteText_Fragment | SeriesSearchBase_ArticleInfogramTile_Fragment | SeriesSearchBase_ArticleInfogramTileParametersTemplate_Fragment | SeriesSearchBase_ArticlePage_Fragment | SeriesSearchBase_ArticleRegion_Fragment | SeriesSearchBase_ArticleRegionsFolder_Fragment | SeriesSearchBase_ArticleSearchPage_Fragment | SeriesSearchBase_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment | SeriesSearchBase_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment | SeriesSearchBase_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment | SeriesSearchBase_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment | SeriesSearchBase_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment | SeriesSearchBase_ArticleSeriesCollection_Fragment | SeriesSearchBase_ArticleSeriesFolder_Fragment | SeriesSearchBase_ArticleSettings_Fragment | SeriesSearchBase_ArticleSubscriptionBanner_Fragment | SeriesSearchBase_ArticleSubscriptionBannerFolder_Fragment | SeriesSearchBase_ArticleTag_Fragment | SeriesSearchBase_ArticleTagsFolder_Fragment | SeriesSearchBase_ArticleTeamAuthor_Fragment | SeriesSearchBase_ArticleTileParametersTemplate_Fragment | SeriesSearchBase_ArticleTilesParametersTemplate_Fragment | SeriesSearchBase_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment | SeriesSearchBase_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment | SeriesSearchBase_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment | SeriesSearchBase_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment | SeriesSearchBase_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment | SeriesSearchBase_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment | SeriesSearchBase_ArticlesGroupFolder_Fragment | SeriesSearchBase_AttachThemeExtension_Fragment | SeriesSearchBase_AutomaticDocumentListings_Fragment | SeriesSearchBase_AutomaticDocumentListingsFolder_Fragment | SeriesSearchBase_AvailableJsonRenderings_Fragment | SeriesSearchBase_AvailableMetaRenderings_Fragment | SeriesSearchBase_AvailableRenderings_Fragment | SeriesSearchBase_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment | SeriesSearchBase_AwardsBanner_Fragment | SeriesSearchBase_AwardsBannerFolder_Fragment | SeriesSearchBase_AwardsBannerImage_Fragment | SeriesSearchBase_AwardsBannerParametersTemplate_Fragment | SeriesSearchBase_ByocWrapperRenderingParameters_Fragment | SeriesSearchBase_BackgroundColorOption_Fragment | SeriesSearchBase_BackgroundColorOptionFolder_Fragment | SeriesSearchBase_BannerFolder_Fragment | SeriesSearchBase_BannerType_Fragment | SeriesSearchBase_BannerTypeFolder_Fragment | SeriesSearchBase_BaseHeading_Fragment | SeriesSearchBase_BaseHeadingFolder_Fragment | SeriesSearchBase_BoolFacet_Fragment | SeriesSearchBase_BranchesFolder_Fragment | SeriesSearchBase_Breadcrumb_Fragment | SeriesSearchBase_BrowserTitleDefinition_Fragment | SeriesSearchBase_CorsEntry_Fragment | SeriesSearchBase_CorsGrouping_Fragment | SeriesSearchBase_CtaPresentationType_Fragment | SeriesSearchBase_CtaPresentationTypeFolder_Fragment | SeriesSearchBase_C__AbrdnPage_Fragment | SeriesSearchBase_C__ActionBase_Fragment | SeriesSearchBase_C__AdvancedParameter_Fragment | SeriesSearchBase_C__App_Fragment | SeriesSearchBase_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment | SeriesSearchBase_C__ArticleWildcardPage_Fragment | SeriesSearchBase_C__AvailableRenderingsFolder_Fragment | SeriesSearchBase_C__ByocRenderingParameters_Fragment | SeriesSearchBase_C__BackgroundParametersTemplate_Fragment | SeriesSearchBase_C__BaseCta_Fragment | SeriesSearchBase_C__BasePage_Fragment | SeriesSearchBase_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment | SeriesSearchBase_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment | SeriesSearchBase_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment | SeriesSearchBase_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment | SeriesSearchBase_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment | SeriesSearchBase_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment | SeriesSearchBase_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment | SeriesSearchBase_C__BaseRenderingParameters_Fragment | SeriesSearchBase_C__BaseTheme_Fragment | SeriesSearchBase_C__BaseVariantField_Fragment | SeriesSearchBase_C__Class_Fragment | SeriesSearchBase_C__CompositeGroup_Fragment | SeriesSearchBase_C__CompositeSection_Fragment | SeriesSearchBase_C__EloquaForm_Fragment | SeriesSearchBase_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment | SeriesSearchBase_C__ExtendedOptions_Fragment | SeriesSearchBase_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment | SeriesSearchBase_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment | SeriesSearchBase_C__FEaaSRenderingParameters_Fragment | SeriesSearchBase_C__FacetSelectorConfigBase_Fragment | SeriesSearchBase_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment | SeriesSearchBase_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment | SeriesSearchBase_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment | SeriesSearchBase_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment | SeriesSearchBase_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment | SeriesSearchBase_C__GlobalDatasourceBehavior_Fragment | SeriesSearchBase_C__GridDefinition_Fragment | SeriesSearchBase_C__GridItemBase_Fragment | SeriesSearchBase_C__GridParameters_Fragment | SeriesSearchBase_C__HeadlessSite_Fragment | SeriesSearchBase_C__HeadlessTenant_Fragment | SeriesSearchBase_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment | SeriesSearchBase_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment | SeriesSearchBase_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment | SeriesSearchBase_C__IAllowEmpty_Fragment | SeriesSearchBase_C__IBaseVariantDefinition_Fragment | SeriesSearchBase_C__IBoosting_Fragment | SeriesSearchBase_C__ICacheable_Fragment | SeriesSearchBase_C__ICompatibleRenderings_Fragment | SeriesSearchBase_C__IComponentVariant_Fragment | SeriesSearchBase_C__IControlType_Fragment | SeriesSearchBase_C__IDynamicPlaceholder_Fragment | SeriesSearchBase_C__IfEaaSComponentsDataSourceTemplates_Fragment | SeriesSearchBase_C__IfEaaSComponentsEditorScriptUrl_Fragment | SeriesSearchBase_C__IIcon_Fragment | SeriesSearchBase_C__ILocation_Fragment | SeriesSearchBase_C__IPaginable_Fragment | SeriesSearchBase_C__IPagination_Fragment | SeriesSearchBase_C__IPoi_Fragment | SeriesSearchBase_C__IRenderingId_Fragment | SeriesSearchBase_C__ISplitter_Fragment | SeriesSearchBase_C__IStyling_Fragment | SeriesSearchBase_C__IVariantDefinition_Fragment | SeriesSearchBase_C__InvestmentTrustPage_Fragment | SeriesSearchBase_C__JsonField_Fragment | SeriesSearchBase_C__JsonReference_Fragment | SeriesSearchBase_C__JssData_Fragment | SeriesSearchBase_C__JssSettings_Fragment | SeriesSearchBase_C__JssSiteFolder_Fragment | SeriesSearchBase_C__JssRootFolder_Fragment | SeriesSearchBase_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment | SeriesSearchBase_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment | SeriesSearchBase_C__Page_Fragment | SeriesSearchBase_C__PageData_Fragment | SeriesSearchBase_C__PageDesignFolder_Fragment | SeriesSearchBase_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment | SeriesSearchBase_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment | SeriesSearchBase_C__PartialDesign_Fragment | SeriesSearchBase_C__PartialDesignFolder_Fragment | SeriesSearchBase_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment | SeriesSearchBase_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment | SeriesSearchBase_C__PlaceholderWrapper_Fragment | SeriesSearchBase_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment | SeriesSearchBase_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment | SeriesSearchBase_C__RedirectMapGrouping_Fragment | SeriesSearchBase_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment | SeriesSearchBase_C__Route_Fragment | SeriesSearchBase_C__SimpleVideo_Fragment | SeriesSearchBase_C__SiteSettingsFolder_Fragment | SeriesSearchBase_C__SitemapSettings_Fragment | SeriesSearchBase_C__StandardTemplate_Fragment | SeriesSearchBase_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment | SeriesSearchBase_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment | SeriesSearchBase_C__TrustFolder_Fragment | SeriesSearchBase_C__VariantDefinition_Fragment | SeriesSearchBase_C__VariantField_Fragment | SeriesSearchBase_C__VariantsGrouping_Fragment | SeriesSearchBase_C___AdvancedItem_Fragment | SeriesSearchBase_C___Arguments_Fragment | SeriesSearchBase_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment | SeriesSearchBase_C___Article_Fragment | SeriesSearchBase_C___ArticlePageWorkflow_Fragment | SeriesSearchBase_C___ArticleSearchPage_Fragment | SeriesSearchBase_C___ArticleWildcard_Fragment | SeriesSearchBase_C___AssetServiceThemeMode_Fragment | SeriesSearchBase_C___BaseArticle_Fragment | SeriesSearchBase_C___BaseDataFolder_Fragment | SeriesSearchBase_C___BaseHelpArticle_Fragment | SeriesSearchBase_C___BaseInvestmentTrust_Fragment | SeriesSearchBase_C___BaseJssTenant_Fragment | SeriesSearchBase_C___BasePage_Fragment | SeriesSearchBase_C___BasePageDesign_Fragment | SeriesSearchBase_C___BasePageDesignFolder_Fragment | SeriesSearchBase_C___BasePartialDesign_Fragment | SeriesSearchBase_C___BasePartialDesignFolder_Fragment | SeriesSearchBase_C___BasePlaceholder_Fragment | SeriesSearchBase_C___BasePlaceholderSettingsFolder_Fragment | SeriesSearchBase_C___BasePresentation_Fragment | SeriesSearchBase_C___BasePressRelease_Fragment | SeriesSearchBase_C___BaseRenderingParameters_Fragment | SeriesSearchBase_C___BaseSxaStandardValuesFolder_Fragment | SeriesSearchBase_C___BaseSettings_Fragment | SeriesSearchBase_C___BaseSharedSitesSettings_Fragment | SeriesSearchBase_C___BaseSiteDefinition_Fragment | SeriesSearchBase_C___BaseSiteFolder_Fragment | SeriesSearchBase_C___BaseSiteGrouping_Fragment | SeriesSearchBase_C___BaseSiteRoot_Fragment | SeriesSearchBase_C___BaseTenant_Fragment | SeriesSearchBase_C___BaseTenantFolder_Fragment | SeriesSearchBase_C___BucketRules_Fragment | SeriesSearchBase_C___Cors_Fragment | SeriesSearchBase_C___Content_Fragment | SeriesSearchBase_C___ContentType_Fragment | SeriesSearchBase_C___DataAttributes_Fragment | SeriesSearchBase_C___DatasourceWorkflow_Fragment | SeriesSearchBase_C___Dependencies_Fragment | SeriesSearchBase_C___Description_Fragment | SeriesSearchBase_C___DesignTemplateMapping_Fragment | SeriesSearchBase_C___Designable_Fragment | SeriesSearchBase_C___EditType_Fragment | SeriesSearchBase_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment | SeriesSearchBase_C___EditingTheme_Fragment | SeriesSearchBase_C___Enabled_Fragment | SeriesSearchBase_C___ErrorHandling_Fragment | SeriesSearchBase_C___ExternalArticle_Fragment | SeriesSearchBase_C___Fields_Fragment | SeriesSearchBase_C___FilteredArticlesParent_Fragment | SeriesSearchBase_C___FilteredArticlesWildcard_Fragment | SeriesSearchBase_C___Footnotes_Fragment | SeriesSearchBase_C___FundDetailsWildcard_Fragment | SeriesSearchBase_C___FundFormAvailability_Fragment | SeriesSearchBase_C___FundMetadataPage_Fragment | SeriesSearchBase_C___FundSearchPage_Fragment | SeriesSearchBase_C___FundsFolder_Fragment | SeriesSearchBase_C___FundsFormsFolder_Fragment | SeriesSearchBase_C___FundsLiteratureFolder_Fragment | SeriesSearchBase_C___FundsShareclassesDetailsWildcard_Fragment | SeriesSearchBase_C___GridMapping_Fragment | SeriesSearchBase_C___HelpArticle_Fragment | SeriesSearchBase_C___HelpArticleSearchPage_Fragment | SeriesSearchBase_C___HelpArticleWildcard_Fragment | SeriesSearchBase_C___HorizonDatasourceGrouping_Fragment | SeriesSearchBase_C___Icon_Fragment | SeriesSearchBase_C___IncludeByDefault_Fragment | SeriesSearchBase_C___IncludeIfInstalled_Fragment | SeriesSearchBase_C___InternalArticle_Fragment | SeriesSearchBase_C___InternetExplorerCompatibilityMode_Fragment | SeriesSearchBase_C___IsSystemModule_Fragment | SeriesSearchBase_C___JsonVariantPaging_Fragment | SeriesSearchBase_C___JsonVariantsBase_Fragment | SeriesSearchBase_C___LimitedDisplay_Fragment | SeriesSearchBase_C___LinkAttributes_Fragment | SeriesSearchBase_C___LinkSettings_Fragment | SeriesSearchBase_C___LiteratureHubSearchPage_Fragment | SeriesSearchBase_C___ManualKeyInformation_Fragment | SeriesSearchBase_C___MemberOf_Fragment | SeriesSearchBase_C___MetadataPage_Fragment | SeriesSearchBase_C___Modules_Fragment | SeriesSearchBase_C___Name_Fragment | SeriesSearchBase_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment | SeriesSearchBase_C___Name_299cdb154745448a807868d401248eaa_Fragment | SeriesSearchBase_C___Name_B88cf88159a54a19991e71038751cb60_Fragment | SeriesSearchBase_C___Navigable_Fragment | SeriesSearchBase_C___NavigablePage_Fragment | SeriesSearchBase_C___PageContent_Fragment | SeriesSearchBase_C___PageWorkflow_Fragment | SeriesSearchBase_C___PerSiteStandardValues_Fragment | SeriesSearchBase_C___Podcast_Fragment | SeriesSearchBase_C___PodcastPressRelease_Fragment | SeriesSearchBase_C___PremiumContentPage_Fragment | SeriesSearchBase_C___PressRelease_Fragment | SeriesSearchBase_C___PressReleaseContentType_Fragment | SeriesSearchBase_C___PressReleaseSearchPage_Fragment | SeriesSearchBase_C___PressReleaseWildcard_Fragment | SeriesSearchBase_C___ProtectedTheme_Fragment | SeriesSearchBase_C___PublishingGroupingTemplate_Fragment | SeriesSearchBase_C___RenderingRelatedParameters_Fragment | SeriesSearchBase_C___RenderingVariantsBase_Fragment | SeriesSearchBase_C___RenderingsList_Fragment | SeriesSearchBase_C___RobotsContent_Fragment | SeriesSearchBase_C___RoleDomain_Fragment | SeriesSearchBase_C___RoleName_Fragment | SeriesSearchBase_C___RoleType_Fragment | SeriesSearchBase_C___SalesforceCommonValidations_Fragment | SeriesSearchBase_C___SalesforceFieldId_Fragment | SeriesSearchBase_C___SalesforceFieldTitle_Fragment | SeriesSearchBase_C___SalesforceFieldValue_Fragment | SeriesSearchBase_C___Script_Fragment | SeriesSearchBase_C___SearchSignature_Fragment | SeriesSearchBase_C___Searchable_Fragment | SeriesSearchBase_C___SecurityItemPointer_Fragment | SeriesSearchBase_C___SharedArticles_Fragment | SeriesSearchBase_C___SharedContent_Fragment | SeriesSearchBase_C___SharedHelpArticles_Fragment | SeriesSearchBase_C___SharedPage_Fragment | SeriesSearchBase_C___SharedPressReleases_Fragment | SeriesSearchBase_C___SharedRoot_Fragment | SeriesSearchBase_C___SharedSettings_Fragment | SeriesSearchBase_C___SiteContent_Fragment | SeriesSearchBase_C___SiteFolder_Fragment | SeriesSearchBase_C___SiteMediaLibrary_Fragment | SeriesSearchBase_C___SiteSettings_Fragment | SeriesSearchBase_C___SiteTemplate_Fragment | SeriesSearchBase_C___SitecoreClientSiteManaging_Fragment | SeriesSearchBase_C___Sitemap_Fragment | SeriesSearchBase_C___SitemapMediaItems_Fragment | SeriesSearchBase_C___SlidersRangeSettings_Fragment | SeriesSearchBase_C___SolutionTemplateContent_Fragment | SeriesSearchBase_C___SolutionTemplateDescription_Fragment | SeriesSearchBase_C___SolutionTemplateName_Fragment | SeriesSearchBase_C___SortOrder_Fragment | SeriesSearchBase_C___StackBreakpoint_Fragment | SeriesSearchBase_C___Statistics_Fragment | SeriesSearchBase_C___SupportedLanguages_Fragment | SeriesSearchBase_C___Taggable_Fragment | SeriesSearchBase_C___TeamMembersParentPage_Fragment | SeriesSearchBase_C___TeamMembersWildcard_Fragment | SeriesSearchBase_C___TechzoneArticle_Fragment | SeriesSearchBase_C___Template_Fragment | SeriesSearchBase_C___Title_Fragment | SeriesSearchBase_C___Type_Fragment | SeriesSearchBase_C___Validation_Fragment | SeriesSearchBase_C___VariantPaging_Fragment | SeriesSearchBase_C___VectorTile_Fragment | SeriesSearchBase_C___VectorTileLink_Fragment | SeriesSearchBase_C___Video_Fragment | SeriesSearchBase_C___VideoPressRelease_Fragment | SeriesSearchBase_C___Width_Fragment | SeriesSearchBase_C___WildcardPage_Fragment | SeriesSearchBase_CacheSetting_Fragment | SeriesSearchBase_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment | SeriesSearchBase_CalendarEvent_Fragment | SeriesSearchBase_CallOutSection_Fragment | SeriesSearchBase_CallOutSectionDropdownOption_Fragment | SeriesSearchBase_CallOutSectionFolder_Fragment | SeriesSearchBase_CallOutSectionParametersTemplate_Fragment | SeriesSearchBase_CallToAction_Fragment | SeriesSearchBase_CallToActionFolder_Fragment | SeriesSearchBase_CapabilitiesFolder_Fragment | SeriesSearchBase_Capability_Fragment | SeriesSearchBase_CapabilityMap_Fragment | SeriesSearchBase_CapabilityMappings_Fragment | SeriesSearchBase_Carousel_Fragment | SeriesSearchBase_CarouselFolder_Fragment | SeriesSearchBase_CarouselSlide_Fragment | SeriesSearchBase_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment | SeriesSearchBase_Checkbox_Fragment | SeriesSearchBase_ChecklistFilter_Fragment | SeriesSearchBase_ChecklistFilterFolder_Fragment | SeriesSearchBase_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment | SeriesSearchBase_ColumnSplitter_Fragment | SeriesSearchBase_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment | SeriesSearchBase_CompatibilityMode_Fragment | SeriesSearchBase_ComponentConfiguration_Fragment | SeriesSearchBase_ComponentThemeConfiguration_Fragment | SeriesSearchBase_ComponentThemesConfiguration_Fragment | SeriesSearchBase_ComponentsConfigurations_Fragment | SeriesSearchBase_ConfigurationFolder_Fragment | SeriesSearchBase_Container_Fragment | SeriesSearchBase_ContainerOption_Fragment | SeriesSearchBase_ContainerOptionsFolder_Fragment | SeriesSearchBase_ContainerParametersTemplate_Fragment | SeriesSearchBase_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment | SeriesSearchBase_ContentBlock_Fragment | SeriesSearchBase_ContentBlockFolder_Fragment | SeriesSearchBase_ContentToken_Fragment | SeriesSearchBase_ContentTokenFolder_Fragment | SeriesSearchBase_ContentType_Fragment | SeriesSearchBase_CorporateTheme_Fragment | SeriesSearchBase_CorporateThemesFolder_Fragment | SeriesSearchBase_Country_Fragment | SeriesSearchBase_CountryIsoCode_Fragment | SeriesSearchBase_CountryIsoCodesFolder_Fragment | SeriesSearchBase_CustomerReviewFolder_Fragment | SeriesSearchBase_CustomerReviewTile_Fragment | SeriesSearchBase_CustomerReviewTileParametersTemplate_Fragment | SeriesSearchBase_DataBridgeDocumentCategoryMap_Fragment | SeriesSearchBase_DataBridgeFund_Fragment | SeriesSearchBase_DataBridgeFundRangeName_Fragment | SeriesSearchBase_DataBridgeSettingsFolder_Fragment | SeriesSearchBase_DataBridgeShareClass_Fragment | SeriesSearchBase_DataFolder_Fragment | SeriesSearchBase_DatasourceConfiguration_Fragment | SeriesSearchBase_DatasourceConfigurations_Fragment | SeriesSearchBase_DatasourceWorkflowAction_Fragment | SeriesSearchBase_DateFacet_Fragment | SeriesSearchBase_DateFilter_Fragment | SeriesSearchBase_DateFilterFolder_Fragment | SeriesSearchBase_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment | SeriesSearchBase_DefaultColumnLayout_Fragment | SeriesSearchBase_DefaultShareclassMapping_Fragment | SeriesSearchBase_DefaultShareclassMappings_Fragment | SeriesSearchBase_DescriptiveHighlight_Fragment | SeriesSearchBase_DescriptiveHighlightFolder_Fragment | SeriesSearchBase_DescriptiveHighlightItem_Fragment | SeriesSearchBase_DescriptiveHighlightParametersTemplate_Fragment | SeriesSearchBase_Device_Fragment | SeriesSearchBase_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment | SeriesSearchBase_Devices_Fragment | SeriesSearchBase_DictionaryFolder_Fragment | SeriesSearchBase_DisqusParameters_Fragment | SeriesSearchBase_DistanceFacet_Fragment | SeriesSearchBase_Divider_Fragment | SeriesSearchBase_DocumentItem_Fragment | SeriesSearchBase_DocumentListings_Fragment | SeriesSearchBase_DocumentListingsFolder_Fragment | SeriesSearchBase_DocumentTypeFolder_Fragment | SeriesSearchBase_DominantLanguageMapping_Fragment | SeriesSearchBase_Dropdown_Fragment | SeriesSearchBase_DropdownFilter_Fragment | SeriesSearchBase_DropdownFilterFolder_Fragment | SeriesSearchBase_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment | SeriesSearchBase_EditEditingTheme_Fragment | SeriesSearchBase_EditFrame_Fragment | SeriesSearchBase_EditModePanel_Fragment | SeriesSearchBase_EditSiteItem_Fragment | SeriesSearchBase_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment | SeriesSearchBase_EditSiteTheme_Fragment | SeriesSearchBase_EditTenantTemplate_Fragment | SeriesSearchBase_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment | SeriesSearchBase_EditType_Fragment | SeriesSearchBase_EloquaFormFolder_Fragment | SeriesSearchBase_EloquaFundForm_Fragment | SeriesSearchBase_Enum_Fragment | SeriesSearchBase_Enums_Fragment | SeriesSearchBase_ErrorPage_Fragment | SeriesSearchBase_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment | SeriesSearchBase_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment | SeriesSearchBase_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment | SeriesSearchBase_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment | SeriesSearchBase_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment | SeriesSearchBase_EventCalendarParameters_Fragment | SeriesSearchBase_EventList_Fragment | SeriesSearchBase_EventListParameters_Fragment | SeriesSearchBase_EventTypes_Fragment | SeriesSearchBase_EventsFolder_Fragment | SeriesSearchBase_ExecuteScript_Fragment | SeriesSearchBase_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment | SeriesSearchBase_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment | SeriesSearchBase_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment | SeriesSearchBase_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment | SeriesSearchBase_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment | SeriesSearchBase_ExtendSiteTheme_Fragment | SeriesSearchBase_ExternalLiterature_Fragment | SeriesSearchBase_FEaaSWrapperRenderingParameters_Fragment | SeriesSearchBase_FacebookCommentsParametersTemplate_Fragment | SeriesSearchBase_FacetSlider_Fragment | SeriesSearchBase_FacetSliderFolder_Fragment | SeriesSearchBase_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment | SeriesSearchBase_FacetSummary_Fragment | SeriesSearchBase_FacetSummaryFolder_Fragment | SeriesSearchBase_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment | SeriesSearchBase_FacetsGrouping_Fragment | SeriesSearchBase_FakeNavigationItem_Fragment | SeriesSearchBase_FeatureBanner_Fragment | SeriesSearchBase_FeatureBannerParametersTemplate_Fragment | SeriesSearchBase_FeaturedArticles_Fragment | SeriesSearchBase_FeaturedArticlesFolder_Fragment | SeriesSearchBase_FeaturedTheme_Fragment | SeriesSearchBase_FeaturedThemesFolder_Fragment | SeriesSearchBase_Feed_Fragment | SeriesSearchBase_FeedFolder_Fragment | SeriesSearchBase_FeedParameters_Fragment | SeriesSearchBase_FieldEditor_Fragment | SeriesSearchBase_FieldRenderer_Fragment | SeriesSearchBase_FileList_Fragment | SeriesSearchBase_FileListFolder_Fragment | SeriesSearchBase_FileListParametersTemplate_Fragment | SeriesSearchBase_File_04129321770849c1801baee196e1c0a8_Fragment | SeriesSearchBase_FilterCriteria_Fragment | SeriesSearchBase_FilterCriteriaFolder_Fragment | SeriesSearchBase_FilterTaxonomyOption_Fragment | SeriesSearchBase_FilterTaxonomyOptions_Fragment | SeriesSearchBase_FilteredArticlesParentPage_Fragment | SeriesSearchBase_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment | SeriesSearchBase_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment | SeriesSearchBase_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment | SeriesSearchBase_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment | SeriesSearchBase_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment | SeriesSearchBase_FilteredArticlesWildcardPage_Fragment | SeriesSearchBase_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment | SeriesSearchBase_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment | SeriesSearchBase_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment | SeriesSearchBase_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment | SeriesSearchBase_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment | SeriesSearchBase_Flip_Fragment | SeriesSearchBase_FlipFolder_Fragment | SeriesSearchBase_Flip_5ef078504c044b839dafefd752cfaba8_Fragment | SeriesSearchBase_Flipside_Fragment | SeriesSearchBase_FloatFacet_Fragment | SeriesSearchBase_Footer_Fragment | SeriesSearchBase_FooterFolder_Fragment | SeriesSearchBase_FooterLink_Fragment | SeriesSearchBase_FormRenderingParameters_Fragment | SeriesSearchBase_FundAssetClass_Fragment | SeriesSearchBase_FundAssetClassesFolder_Fragment | SeriesSearchBase_FundDetailsWildcardPage_Fragment | SeriesSearchBase_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment | SeriesSearchBase_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment | SeriesSearchBase_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment | SeriesSearchBase_FundFormsFolder_Fragment | SeriesSearchBase_FundInFocus_Fragment | SeriesSearchBase_FundInFocusShareClass_Fragment | SeriesSearchBase_FundSearchPage_Fragment | SeriesSearchBase_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment | SeriesSearchBase_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment | SeriesSearchBase_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment | SeriesSearchBase_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment | SeriesSearchBase_FundSettings_Fragment | SeriesSearchBase_FundShareclassDetailsWildcardPage_Fragment | SeriesSearchBase_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment | SeriesSearchBase_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment | SeriesSearchBase_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment | SeriesSearchBase_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment | SeriesSearchBase_FundSubAssetClass_Fragment | SeriesSearchBase_FundSubAssetClassesFolder_Fragment | SeriesSearchBase_FundsExternalLiteratureFolder_Fragment | SeriesSearchBase_FundsFolder_Fragment | SeriesSearchBase_FundsInFocusFolder_Fragment | SeriesSearchBase_FundsInFocusParametersTemplate_Fragment | SeriesSearchBase_FundsLiteratureFolder_Fragment | SeriesSearchBase_FundsLiteratureMappingsFolder_Fragment | SeriesSearchBase_Gallery_Fragment | SeriesSearchBase_GalleryFolder_Fragment | SeriesSearchBase_GalleryImage_Fragment | SeriesSearchBase_GalleryParametersTemplate_Fragment | SeriesSearchBase_GalleryVideo_Fragment | SeriesSearchBase_GatedAccordionContainer_Fragment | SeriesSearchBase_GlobalLanguageSelector_Fragment | SeriesSearchBase_GlobalNavigationBar_Fragment | SeriesSearchBase_GoogleAnalytics_Fragment | SeriesSearchBase_GoogleTagManager_Fragment | SeriesSearchBase_GoogleTagManagerFolder_Fragment | SeriesSearchBase_GridSetup_Fragment | SeriesSearchBase_GridTheme_Fragment | SeriesSearchBase_HtmlCode_Fragment | SeriesSearchBase_HtmlCodeFolder_Fragment | SeriesSearchBase_HtmlInclude_Fragment | SeriesSearchBase_HtmlIncludesFolder_Fragment | SeriesSearchBase_HtmlSnippet_Fragment | SeriesSearchBase_HtmlSnippetFolder_Fragment | SeriesSearchBase_HtmlTag_Fragment | SeriesSearchBase_Header_Fragment | SeriesSearchBase_HeaderFolder_Fragment | SeriesSearchBase_Heading_Fragment | SeriesSearchBase_HeadlessSiteSetupRoot_Fragment | SeriesSearchBase_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment | SeriesSearchBase_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment | SeriesSearchBase_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment | SeriesSearchBase_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment | SeriesSearchBase_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment | SeriesSearchBase_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment | SeriesSearchBase_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment | SeriesSearchBase_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment | SeriesSearchBase_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment | SeriesSearchBase_HeadlessSolutionTemplateFolder_Fragment | SeriesSearchBase_HeadlessTenantSetupRoot_Fragment | SeriesSearchBase_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment | SeriesSearchBase_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment | SeriesSearchBase_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment | SeriesSearchBase_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment | SeriesSearchBase_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment | SeriesSearchBase_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment | SeriesSearchBase_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment | SeriesSearchBase_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment | SeriesSearchBase_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment | SeriesSearchBase_HeadlessTrustSite_Fragment | SeriesSearchBase_HeadlessVariants_Fragment | SeriesSearchBase_HeadlessVariantsGrouping_Fragment | SeriesSearchBase_HelpArticlePage_Fragment | SeriesSearchBase_HelpArticlePlatform_Fragment | SeriesSearchBase_HelpArticlePlatformMap_Fragment | SeriesSearchBase_HelpArticlePlatformMappings_Fragment | SeriesSearchBase_HelpArticlePlatformsFolder_Fragment | SeriesSearchBase_HelpArticleSearchPage_Fragment | SeriesSearchBase_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment | SeriesSearchBase_HelpArticleTag_Fragment | SeriesSearchBase_HelpArticleTagsFolder_Fragment | SeriesSearchBase_HelpArticleWildcardPage_Fragment | SeriesSearchBase_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment | SeriesSearchBase_HelpArticlesGroupFolder_Fragment | SeriesSearchBase_HelpTagMap_Fragment | SeriesSearchBase_HelpTagMappings_Fragment | SeriesSearchBase_HeroBanner_Fragment | SeriesSearchBase_Highlight_Fragment | SeriesSearchBase_HighlightBlock_Fragment | SeriesSearchBase_HighlightBlockFolder_Fragment | SeriesSearchBase_HighlightBlockParametersTemplate_Fragment | SeriesSearchBase_HighlightFolder_Fragment | SeriesSearchBase_HighlightItem_Fragment | SeriesSearchBase_HighlightParametersTemplate_Fragment | SeriesSearchBase_Home_Fragment | SeriesSearchBase_HomePage_Fragment | SeriesSearchBase_HomePage_0d3963a8171d4080b5f808618578b631_Fragment | SeriesSearchBase_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment | SeriesSearchBase_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment | SeriesSearchBase_HomePage_Cde13c51062d426b95569e8202edc963_Fragment | SeriesSearchBase_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment | SeriesSearchBase_IFrame_Fragment | SeriesSearchBase_IFrameFolder_Fragment | SeriesSearchBase_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment | SeriesSearchBase_IFrameParametersTemplate_Fragment | SeriesSearchBase_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment | SeriesSearchBase_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment | SeriesSearchBase_Icon_Fragment | SeriesSearchBase_IconFolder_Fragment | SeriesSearchBase_Image_Fragment | SeriesSearchBase_ImageFolder_Fragment | SeriesSearchBase_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment | SeriesSearchBase_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment | SeriesSearchBase_ImageParametersTemplate_Fragment | SeriesSearchBase_Image_83bc563c6320490092f8204bff81586a_Fragment | SeriesSearchBase_Image_15185b0e641844499f934ff03b7ee032_Fragment | SeriesSearchBase_Image_D885df8cb2d64007b34b2bbafb527304_Fragment | SeriesSearchBase_Infographics_Fragment | SeriesSearchBase_InfographicsFolder_Fragment | SeriesSearchBase_InputValidationStep_Fragment | SeriesSearchBase_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment | SeriesSearchBase_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment | SeriesSearchBase_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment | SeriesSearchBase_IntegerFacet_Fragment | SeriesSearchBase_IntroCopy_Fragment | SeriesSearchBase_IntroCopyFolder_Fragment | SeriesSearchBase_InvestmentTrustAssetClass_Fragment | SeriesSearchBase_InvestmentTrustAssetClassFolder_Fragment | SeriesSearchBase_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment | SeriesSearchBase_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment | SeriesSearchBase_InvestmentTrustRegion_Fragment | SeriesSearchBase_InvestmentTrustRegionFolder_Fragment | SeriesSearchBase_InvestmentTrustStyle_Fragment | SeriesSearchBase_InvestmentTrustStyleFolder_Fragment | SeriesSearchBase_InvestorType_Fragment | SeriesSearchBase_InvestorTypesFolder_Fragment | SeriesSearchBase_ItemQueriesFolder_Fragment | SeriesSearchBase_ItemRights_Fragment | SeriesSearchBase_JsBeaconSettings_Fragment | SeriesSearchBase_JsonCheckbox_Fragment | SeriesSearchBase_JsonContent_Fragment | SeriesSearchBase_JsonDate_Fragment | SeriesSearchBase_JsonFile_Fragment | SeriesSearchBase_JsonImage_Fragment | SeriesSearchBase_JsonLayout_Fragment | SeriesSearchBase_JsonList_Fragment | SeriesSearchBase_JsonMultilistReference_Fragment | SeriesSearchBase_JsonPlaceholder_Fragment | SeriesSearchBase_JsonQuery_Fragment | SeriesSearchBase_JsonResults_Fragment | SeriesSearchBase_JsonRichText_Fragment | SeriesSearchBase_JsonScriban_Fragment | SeriesSearchBase_JsonSection_Fragment | SeriesSearchBase_JsonTemplate_Fragment | SeriesSearchBase_JsonText_Fragment | SeriesSearchBase_JsonToken_Fragment | SeriesSearchBase_JsonVariantDefinition_Fragment | SeriesSearchBase_JsonVariants_Fragment | SeriesSearchBase_JssLayout_Fragment | SeriesSearchBase_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment | SeriesSearchBase_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment | SeriesSearchBase_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment | SeriesSearchBase_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment | SeriesSearchBase_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment | SeriesSearchBase_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment | SeriesSearchBase_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment | SeriesSearchBase_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment | SeriesSearchBase_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment | SeriesSearchBase_JssSiteGrouping_Fragment | SeriesSearchBase_JssTenantFolder_Fragment | SeriesSearchBase_JavaScriptRendering_Fragment | SeriesSearchBase_JsonRendering_Fragment | SeriesSearchBase_JurisdictionStatus_Fragment | SeriesSearchBase_JurisdictionsFolder_Fragment | SeriesSearchBase_KeyHighlightItem_Fragment | SeriesSearchBase_KeyHighlights_Fragment | SeriesSearchBase_KeyHighlightsFolder_Fragment | SeriesSearchBase_KeyHighlightsParametersTemplate_Fragment | SeriesSearchBase_Language_Fragment | SeriesSearchBase_LanguageSelector_Fragment | SeriesSearchBase_LanguagesFolder_Fragment | SeriesSearchBase_LatestPressReleasesParametersTemplate_Fragment | SeriesSearchBase_LayoutServiceVariants_Fragment | SeriesSearchBase_LimitedDisplayFolder_Fragment | SeriesSearchBase_LimitedDisplayOption_Fragment | SeriesSearchBase_Link_Fragment | SeriesSearchBase_LinkList_Fragment | SeriesSearchBase_LinkListFolder_Fragment | SeriesSearchBase_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment | SeriesSearchBase_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment | SeriesSearchBase_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment | SeriesSearchBase_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment | SeriesSearchBase_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment | SeriesSearchBase_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment | SeriesSearchBase_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment | SeriesSearchBase_LinksFolder_Fragment | SeriesSearchBase_List_Fragment | SeriesSearchBase_ListFacet_Fragment | SeriesSearchBase_ListFolder_Fragment | SeriesSearchBase_ListItem_Fragment | SeriesSearchBase_ListParametersTemplate_Fragment | SeriesSearchBase_ListStyle_Fragment | SeriesSearchBase_ListStyleItem_Fragment | SeriesSearchBase_ListingHeroBanner_Fragment | SeriesSearchBase_ListingHeroParametersTemplate_Fragment | SeriesSearchBase_LiteratureAuthorization_Fragment | SeriesSearchBase_LiteratureAuthorizationsFolder_Fragment | SeriesSearchBase_LiteratureHubSearchPage_Fragment | SeriesSearchBase_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment | SeriesSearchBase_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment | SeriesSearchBase_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment | SeriesSearchBase_LoadMore_Fragment | SeriesSearchBase_LoadMoreFolder_Fragment | SeriesSearchBase_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment | SeriesSearchBase_LocationFilter_Fragment | SeriesSearchBase_LocationFilterFolder_Fragment | SeriesSearchBase_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment | SeriesSearchBase_Log_Fragment | SeriesSearchBase_Login_Fragment | SeriesSearchBase_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment | SeriesSearchBase_LogoTextBlockItem_Fragment | SeriesSearchBase_LogoTextBlocks_Fragment | SeriesSearchBase_LogoTextBlocksFolder_Fragment | SeriesSearchBase_Logout_Fragment | SeriesSearchBase_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment | SeriesSearchBase_ManagedRangeFilter_Fragment | SeriesSearchBase_ManagedRangeFilterFolder_Fragment | SeriesSearchBase_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment | SeriesSearchBase_ManagedRangeItem_Fragment | SeriesSearchBase_Map_Fragment | SeriesSearchBase_MapParameters_Fragment | SeriesSearchBase_MapsFolder_Fragment | SeriesSearchBase_MapsProvider_Fragment | SeriesSearchBase_MediaBlock_Fragment | SeriesSearchBase_MediaBlockFolder_Fragment | SeriesSearchBase_MediaBlockParametersTemplate_Fragment | SeriesSearchBase_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment | SeriesSearchBase_MediaLinkParameters_Fragment | SeriesSearchBase_MediaVirtualFolder_Fragment | SeriesSearchBase_MegaNavigation_Fragment | SeriesSearchBase_MegaNavigationFolder_Fragment | SeriesSearchBase_MetaBranding_Fragment | SeriesSearchBase_MetaRenderingParameters_Fragment | SeriesSearchBase_MetadataPartialDesign_Fragment | SeriesSearchBase_Model_Fragment | SeriesSearchBase_ModelIterator_Fragment | SeriesSearchBase_MyLocationPoi_Fragment | SeriesSearchBase_Navigation_Fragment | SeriesSearchBase_NavigationCategory_Fragment | SeriesSearchBase_NavigationFilter_Fragment | SeriesSearchBase_NavigationFilterFolder_Fragment | SeriesSearchBase_NavigationLink_Fragment | SeriesSearchBase_NavigationSubcategory_Fragment | SeriesSearchBase_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment | SeriesSearchBase_OneTrustSettings_Fragment | SeriesSearchBase_OptimiserConfiguration_Fragment | SeriesSearchBase_OptimiserConfigurationSection_Fragment | SeriesSearchBase_OptimizedFile_Fragment | SeriesSearchBase_OracleCdpSettings_Fragment | SeriesSearchBase_OverlayContent_Fragment | SeriesSearchBase_OverlayFolderTemplate_Fragment | SeriesSearchBase_Ownership_Fragment | SeriesSearchBase_OwnershipFolder_Fragment | SeriesSearchBase_Poi_Fragment | SeriesSearchBase_PoiFolder_Fragment | SeriesSearchBase_PoiType_Fragment | SeriesSearchBase_PoIs_Fragment | SeriesSearchBase_PageBranchesFolder_Fragment | SeriesSearchBase_PageContent_Fragment | SeriesSearchBase_PageContentFolder_Fragment | SeriesSearchBase_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment | SeriesSearchBase_PageDesign_Fragment | SeriesSearchBase_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment | SeriesSearchBase_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment | SeriesSearchBase_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment | SeriesSearchBase_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment | SeriesSearchBase_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment | SeriesSearchBase_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment | SeriesSearchBase_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment | SeriesSearchBase_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment | SeriesSearchBase_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment | SeriesSearchBase_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment | SeriesSearchBase_PageDesigns_Fragment | SeriesSearchBase_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment | SeriesSearchBase_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment | SeriesSearchBase_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment | SeriesSearchBase_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment | SeriesSearchBase_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment | SeriesSearchBase_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment | SeriesSearchBase_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment | SeriesSearchBase_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment | SeriesSearchBase_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment | SeriesSearchBase_PageLevelTabs_Fragment | SeriesSearchBase_PageLevelTabsFolder_Fragment | SeriesSearchBase_PageList_Fragment | SeriesSearchBase_PageSelector_Fragment | SeriesSearchBase_PageSelectorConfiguration_Fragment | SeriesSearchBase_PageSelectorFolder_Fragment | SeriesSearchBase_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment | SeriesSearchBase_PageSize_Fragment | SeriesSearchBase_PageSizeFolder_Fragment | SeriesSearchBase_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment | SeriesSearchBase_PageTheme_Fragment | SeriesSearchBase_PageThemesFolder_Fragment | SeriesSearchBase_Page_4f49a81db3664f198b89cab92f377d7a_Fragment | SeriesSearchBase_Page_5e66d86353544fe6a27d3b894984d50f_Fragment | SeriesSearchBase_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment | SeriesSearchBase_Page_718df200be51463d93edf4d77ab7a49e_Fragment | SeriesSearchBase_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment | SeriesSearchBase_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment | SeriesSearchBase_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment | SeriesSearchBase_Page_Fa608b3e6aeb426388a059d89caabada_Fragment | SeriesSearchBase_Pagging_Fragment | SeriesSearchBase_Pagination_Fragment | SeriesSearchBase_PaginationFolder_Fragment | SeriesSearchBase_Paragraph_Fragment | SeriesSearchBase_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment | SeriesSearchBase_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment | SeriesSearchBase_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment | SeriesSearchBase_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment | SeriesSearchBase_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment | SeriesSearchBase_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment | SeriesSearchBase_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment | SeriesSearchBase_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment | SeriesSearchBase_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment | SeriesSearchBase_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment | SeriesSearchBase_PartialDesigns_Fragment | SeriesSearchBase_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment | SeriesSearchBase_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment | SeriesSearchBase_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment | SeriesSearchBase_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment | SeriesSearchBase_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment | SeriesSearchBase_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment | SeriesSearchBase_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment | SeriesSearchBase_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment | SeriesSearchBase_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment | SeriesSearchBase_PerformanceChartSettings_Fragment | SeriesSearchBase_PerformanceChartTimePeriod_Fragment | SeriesSearchBase_PerformanceChartTimePeriodFolder_Fragment | SeriesSearchBase_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment | SeriesSearchBase_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment | SeriesSearchBase_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment | SeriesSearchBase_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment | SeriesSearchBase_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment | SeriesSearchBase_PlainHtmlParametersTemplate_Fragment | SeriesSearchBase_Playlist_Fragment | SeriesSearchBase_PlaylistFolder_Fragment | SeriesSearchBase_PlaylistParametersTemplate_Fragment | SeriesSearchBase_Podcast_Fragment | SeriesSearchBase_PodcastFolder_Fragment | SeriesSearchBase_PodcastPage_Fragment | SeriesSearchBase_PodcastPressReleasePage_Fragment | SeriesSearchBase_PoiTypes_Fragment | SeriesSearchBase_PostDeleteStep_Fragment | SeriesSearchBase_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment | SeriesSearchBase_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment | SeriesSearchBase_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment | SeriesSearchBase_PostSetupStep_Fragment | SeriesSearchBase_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment | SeriesSearchBase_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment | SeriesSearchBase_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment | SeriesSearchBase_PreDeleteStep_Fragment | SeriesSearchBase_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment | SeriesSearchBase_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment | SeriesSearchBase_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment | SeriesSearchBase_PreDeleteValidationStep_Fragment | SeriesSearchBase_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment | SeriesSearchBase_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment | SeriesSearchBase_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment | SeriesSearchBase_Presentation_Fragment | SeriesSearchBase_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment | SeriesSearchBase_PressReleaseContentType_Fragment | SeriesSearchBase_PressReleaseContentTypesFolder_Fragment | SeriesSearchBase_PressReleaseFilter_Fragment | SeriesSearchBase_PressReleasePage_Fragment | SeriesSearchBase_PressReleasePlatform_Fragment | SeriesSearchBase_PressReleasePlatformsFolder_Fragment | SeriesSearchBase_PressReleaseSearchPage_Fragment | SeriesSearchBase_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment | SeriesSearchBase_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment | SeriesSearchBase_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment | SeriesSearchBase_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment | SeriesSearchBase_PressReleaseWildcardPage_Fragment | SeriesSearchBase_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment | SeriesSearchBase_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment | SeriesSearchBase_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment | SeriesSearchBase_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment | SeriesSearchBase_PressReleasesGroupFolder_Fragment | SeriesSearchBase_PrivacyWarning_Fragment | SeriesSearchBase_ProjectFolder_Fragment | SeriesSearchBase_Promo_Fragment | SeriesSearchBase_PromoFolder_Fragment | SeriesSearchBase_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment | SeriesSearchBase_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment | SeriesSearchBase_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment | SeriesSearchBase_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment | SeriesSearchBase_PromotedContent_Fragment | SeriesSearchBase_PromotedContentFolder_Fragment | SeriesSearchBase_PropertyListingCard_Fragment | SeriesSearchBase_PropertyListingCards_Fragment | SeriesSearchBase_PropertyListingCategory_Fragment | SeriesSearchBase_PropertyListingFolder_Fragment | SeriesSearchBase_Query_98b413525a4b4067b92418a4b50f0a53_Fragment | SeriesSearchBase_QuickLinks_Fragment | SeriesSearchBase_QuickLinksFolder_Fragment | SeriesSearchBase_QuickLinksParametersTemplate_Fragment | SeriesSearchBase_QuotationBlockItem_Fragment | SeriesSearchBase_QuotationBlocks_Fragment | SeriesSearchBase_QuotationBlocksFolder_Fragment | SeriesSearchBase_QuotationBlocksParametersTemplate_Fragment | SeriesSearchBase_Quote_Fragment | SeriesSearchBase_QuoteFolder_Fragment | SeriesSearchBase_QuoteParametersTemplate_Fragment | SeriesSearchBase_RadiusFilter_Fragment | SeriesSearchBase_RadiusFilterFolder_Fragment | SeriesSearchBase_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment | SeriesSearchBase_RadiusScheme_Fragment | SeriesSearchBase_RadiusSchemeValue_Fragment | SeriesSearchBase_RangeSliderFilter_Fragment | SeriesSearchBase_RangeSliderFilterFolder_Fragment | SeriesSearchBase_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment | SeriesSearchBase_RecentArticles_Fragment | SeriesSearchBase_Redirect_Fragment | SeriesSearchBase_RedirectMap_Fragment | SeriesSearchBase_RedirectMaps_Fragment | SeriesSearchBase_Region_Fragment | SeriesSearchBase_RegionLanguages_Fragment | SeriesSearchBase_RegionLanguagesFolder_Fragment | SeriesSearchBase_RelatedArticles_Fragment | SeriesSearchBase_RelatedArticlesParametersTemplate_Fragment | SeriesSearchBase_RenderEngineType_Fragment | SeriesSearchBase_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment | SeriesSearchBase_RenderingHost_Fragment | SeriesSearchBase_ResizableIFramePage_Fragment | SeriesSearchBase_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment | SeriesSearchBase_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment | SeriesSearchBase_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment | SeriesSearchBase_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment | SeriesSearchBase_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment | SeriesSearchBase_ResponsiveImage_Fragment | SeriesSearchBase_ResultsCount_Fragment | SeriesSearchBase_ResultsCountFolder_Fragment | SeriesSearchBase_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment | SeriesSearchBase_ResultsVariantSelector_Fragment | SeriesSearchBase_RichText_Fragment | SeriesSearchBase_RichTextFolder_Fragment | SeriesSearchBase_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment | SeriesSearchBase_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment | SeriesSearchBase_RiskImageMapping_Fragment | SeriesSearchBase_RiskImageMappings_Fragment | SeriesSearchBase_RiskLevelOption_Fragment | SeriesSearchBase_RiskLevelOptionFolder_Fragment | SeriesSearchBase_RiskWarning_Fragment | SeriesSearchBase_RiskWarningFolder_Fragment | SeriesSearchBase_RiskWarningParametersTemplate_Fragment | SeriesSearchBase_RolePlaceholder_Fragment | SeriesSearchBase_RowSplitter_Fragment | SeriesSearchBase_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment | SeriesSearchBase_Rule_Fragment | SeriesSearchBase_SdrLogoMapping_Fragment | SeriesSearchBase_SdrLogoMappings_Fragment | SeriesSearchBase_SdrTypeOption_Fragment | SeriesSearchBase_SdrTypeOptionFolder_Fragment | SeriesSearchBase_SxajssLayout_Fragment | SeriesSearchBase_SxaRole_Fragment | SeriesSearchBase_SxaStandardValuesFolder_Fragment | SeriesSearchBase_SalesforceAlertMessage_Fragment | SeriesSearchBase_SalesforceCheckBox_Fragment | SeriesSearchBase_SalesforceCheckBoxType_Fragment | SeriesSearchBase_SalesforceConditionalRadioButton_Fragment | SeriesSearchBase_SalesforceConditionalRadioButtons_Fragment | SeriesSearchBase_SalesforceDateInput_Fragment | SeriesSearchBase_SalesforceDropdown_Fragment | SeriesSearchBase_SalesforceDropdownOption_Fragment | SeriesSearchBase_SalesforceHiddenField_Fragment | SeriesSearchBase_SalesforceInput_Fragment | SeriesSearchBase_SalesforceInputType_Fragment | SeriesSearchBase_SalesforceIntegratedForm_Fragment | SeriesSearchBase_SalesforceIntegratedFormTypesFolder_Fragment | SeriesSearchBase_SalesforceRepeatableSubSection_Fragment | SeriesSearchBase_SalesforceRichTextArea_Fragment | SeriesSearchBase_SalesforceSection_Fragment | SeriesSearchBase_SalesforceSortCodeInput_Fragment | SeriesSearchBase_SalesforceSubmissionType_Fragment | SeriesSearchBase_Scope_Fragment | SeriesSearchBase_ScopesFolder_Fragment | SeriesSearchBase_Scriban_Fragment | SeriesSearchBase_Scripts_Fragment | SeriesSearchBase_SearchBox_Fragment | SeriesSearchBase_SearchBoxFolder_Fragment | SeriesSearchBase_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment | SeriesSearchBase_SearchFolder_Fragment | SeriesSearchBase_SearchResults_Fragment | SeriesSearchBase_SearchResultsFolder_Fragment | SeriesSearchBase_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment | SeriesSearchBase_SecondaryHeroBannerParametersTemplate_Fragment | SeriesSearchBase_SectionHeading_Fragment | SeriesSearchBase_SectionHeadingFolder_Fragment | SeriesSearchBase_SectionHeadingParametersTemplate_Fragment | SeriesSearchBase_SectionHeadingType_Fragment | SeriesSearchBase_SectionHeadingTypeFolder_Fragment | SeriesSearchBase_SectionSelector_Fragment | SeriesSearchBase_SectionSelectorFolder_Fragment | SeriesSearchBase_SectionSelectorTab_Fragment | SeriesSearchBase_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment | SeriesSearchBase_Series_Fragment | SeriesSearchBase_SeriesFolder_Fragment | SeriesSearchBase_Settings_Fragment | SeriesSearchBase_SettingsFolder_Fragment | SeriesSearchBase_Settings_6c82caca67dc464195698faad083230e_Fragment | SeriesSearchBase_SharePriceSettings_Fragment | SeriesSearchBase_SharedArticlesFolder_Fragment | SeriesSearchBase_SharedContentFolder_Fragment | SeriesSearchBase_SharedFolder_Fragment | SeriesSearchBase_SharedHelpArticlesFolder_Fragment | SeriesSearchBase_SharedPressReleasesFolder_Fragment | SeriesSearchBase_SharedSettingsFolder_Fragment | SeriesSearchBase_SharedSitesSettings_Fragment | SeriesSearchBase_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment | SeriesSearchBase_Showcase_Fragment | SeriesSearchBase_ShowcaseFolder_Fragment | SeriesSearchBase_ShowcaseItem_Fragment | SeriesSearchBase_ShowcaseParametersTemplate_Fragment | SeriesSearchBase_Site_Fragment | SeriesSearchBase_SiteContentFolder_Fragment | SeriesSearchBase_SiteDefinition_Fragment | SeriesSearchBase_SiteEntryDisclaimer_Fragment | SeriesSearchBase_SiteFolder_Fragment | SeriesSearchBase_SiteGrouping_Fragment | SeriesSearchBase_SiteManagement_Fragment | SeriesSearchBase_SiteSecurityItemPointer_Fragment | SeriesSearchBase_SiteSelector_Fragment | SeriesSearchBase_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment | SeriesSearchBase_SiteSetupRoot_Fragment | SeriesSearchBase_SiteTheme_Fragment | SeriesSearchBase_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment | SeriesSearchBase_SitecoreFormWrapperParametersTemplate_Fragment | SeriesSearchBase_SitecoreRole_Fragment | SeriesSearchBase_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment | SeriesSearchBase_SkipLink_Fragment | SeriesSearchBase_SkipLinkParameters_Fragment | SeriesSearchBase_SkipLinksFolder_Fragment | SeriesSearchBase_Snippet_Fragment | SeriesSearchBase_SnippetItem_Fragment | SeriesSearchBase_SnippetsFolder_Fragment | SeriesSearchBase_SocialLoginWrapper_Fragment | SeriesSearchBase_SocialMediaButtons_Fragment | SeriesSearchBase_SocialMediaFolder_Fragment | SeriesSearchBase_SocialMediaShare_Fragment | SeriesSearchBase_SocialMediaTemplate_Fragment | SeriesSearchBase_SocialNetwork_Fragment | SeriesSearchBase_SocialNetworkFolder_Fragment | SeriesSearchBase_SocialNetworkLink_Fragment | SeriesSearchBase_SolutionTemplate_Fragment | SeriesSearchBase_SortResults_Fragment | SeriesSearchBase_SortResultsFolder_Fragment | SeriesSearchBase_Sorting_Fragment | SeriesSearchBase_SortingGroups_Fragment | SeriesSearchBase_SpotifyPodcast_Fragment | SeriesSearchBase_SpotifyPodcastFolder_Fragment | SeriesSearchBase_StickyCta_Fragment | SeriesSearchBase_StickyCtaFolder_Fragment | SeriesSearchBase_StickyCtaParametersTemplate_Fragment | SeriesSearchBase_StrategiesInFocusFolder_Fragment | SeriesSearchBase_StrategyInFocus_Fragment | SeriesSearchBase_Style_Fragment | SeriesSearchBase_Styles_Fragment | SeriesSearchBase_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment | SeriesSearchBase_SubscriptionBannerParametersTemplate_Fragment | SeriesSearchBase_Tab_Fragment | SeriesSearchBase_TabItem_Fragment | SeriesSearchBase_TableOfContents_Fragment | SeriesSearchBase_TableOfContentsFolder_Fragment | SeriesSearchBase_TableOfContentsSection_Fragment | SeriesSearchBase_TableOfContentsSubsection_Fragment | SeriesSearchBase_Tabs_Fragment | SeriesSearchBase_TabsFolder_Fragment | SeriesSearchBase_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment | SeriesSearchBase_Tag_Fragment | SeriesSearchBase_TagCloud_Fragment | SeriesSearchBase_TagFolder_Fragment | SeriesSearchBase_TagList_Fragment | SeriesSearchBase_TeamBiographySettings_Fragment | SeriesSearchBase_TeamListingCards_Fragment | SeriesSearchBase_TeamListingCardsFolder_Fragment | SeriesSearchBase_TeamMember_Fragment | SeriesSearchBase_TeamMemberCard_Fragment | SeriesSearchBase_TeamMembers_Fragment | SeriesSearchBase_TeamMembersParentPage_Fragment | SeriesSearchBase_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment | SeriesSearchBase_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment | SeriesSearchBase_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment | SeriesSearchBase_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment | SeriesSearchBase_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment | SeriesSearchBase_TeamMembersWildcardPage_Fragment | SeriesSearchBase_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment | SeriesSearchBase_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment | SeriesSearchBase_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment | SeriesSearchBase_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment | SeriesSearchBase_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment | SeriesSearchBase_TeamProfileCards_Fragment | SeriesSearchBase_TeamProfileCardsFolder_Fragment | SeriesSearchBase_TechzoneArticlePage_Fragment | SeriesSearchBase_Tenant_Fragment | SeriesSearchBase_TenantFolder_Fragment | SeriesSearchBase_TenantSecurityItemPointer_Fragment | SeriesSearchBase_TenantSetupRoot_Fragment | SeriesSearchBase_TertieryHeroBanner_Fragment | SeriesSearchBase_TertieryHeroBannerParametersTemplate_Fragment | SeriesSearchBase_Text_Fragment | SeriesSearchBase_TextBlock_Fragment | SeriesSearchBase_TextBlockHeadingParametersTemplate_Fragment | SeriesSearchBase_TextBlockHeadingType_Fragment | SeriesSearchBase_TextBlockHeadingTypeFolder_Fragment | SeriesSearchBase_TextBlockLinkType_Fragment | SeriesSearchBase_TextBlockLinkTypeFolder_Fragment | SeriesSearchBase_TextBlocks_Fragment | SeriesSearchBase_TextBlocksFolder_Fragment | SeriesSearchBase_TextBlocksParametersTemplate_Fragment | SeriesSearchBase_TextFolder_Fragment | SeriesSearchBase_TextFolder_B762d56787f5493cbb480c455d834457_Fragment | SeriesSearchBase_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment | SeriesSearchBase_Theme_Fragment | SeriesSearchBase_ThemeTag_Fragment | SeriesSearchBase_ThemeTagsFolder_Fragment | SeriesSearchBase_ThemingMode_Fragment | SeriesSearchBase_ThemingModes_Fragment | SeriesSearchBase_Tile_Fragment | SeriesSearchBase_TileLink_Fragment | SeriesSearchBase_TileParametersTemplate_Fragment | SeriesSearchBase_TileSizeOption_Fragment | SeriesSearchBase_TileSizeOptionFolder_Fragment | SeriesSearchBase_TilesFolder_Fragment | SeriesSearchBase_TilesParametersTemplate_Fragment | SeriesSearchBase_Title_Fragment | SeriesSearchBase_Title_A82e893105754175917de904ef7e6dbe_Fragment | SeriesSearchBase_Toggle_Fragment | SeriesSearchBase_ToggleFolder_Fragment | SeriesSearchBase_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment | SeriesSearchBase_Transformation_Fragment | SeriesSearchBase_TrustArticleHeroParametersTemplate_Fragment | SeriesSearchBase_TrustFinder_Fragment | SeriesSearchBase_TrustFinderFilterOption_Fragment | SeriesSearchBase_TrustRegion_Fragment | SeriesSearchBase_TrustType_Fragment | SeriesSearchBase_TrustTypesFolder_Fragment | SeriesSearchBase_Twitter_Fragment | SeriesSearchBase_TwitterApp_Fragment | SeriesSearchBase_TwitterApps_Fragment | SeriesSearchBase_TwitterFolder_Fragment | SeriesSearchBase_TwitterParametersTemplate_Fragment | SeriesSearchBase_TwitterSettings_Fragment | SeriesSearchBase_UnknownItem_Fragment | SeriesSearchBase_UnminifiedFile_Fragment | SeriesSearchBase_UpgradeScript_Fragment | SeriesSearchBase_UpgradeScriptLibrary_Fragment | SeriesSearchBase_VariantComponentField_Fragment | SeriesSearchBase_VariantDateField_Fragment | SeriesSearchBase_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment | SeriesSearchBase_VariantPlaceholder_Fragment | SeriesSearchBase_VariantReference_Fragment | SeriesSearchBase_VariantSection_Fragment | SeriesSearchBase_VariantTemplate_Fragment | SeriesSearchBase_VariantText_Fragment | SeriesSearchBase_VariantToken_Fragment | SeriesSearchBase_Variants_Fragment | SeriesSearchBase_VectorFolder_Fragment | SeriesSearchBase_VectorTile_Fragment | SeriesSearchBase_VectorTileLink_Fragment | SeriesSearchBase_VectorTilesFolder_Fragment | SeriesSearchBase_VectorTilesParametersTemplate_Fragment | SeriesSearchBase_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment | SeriesSearchBase_Video_Fragment | SeriesSearchBase_VideoCountOption_Fragment | SeriesSearchBase_VideoCountOptions_Fragment | SeriesSearchBase_VideoFolder_Fragment | SeriesSearchBase_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment | SeriesSearchBase_VideoPage_Fragment | SeriesSearchBase_VideoParameters_Fragment | SeriesSearchBase_VideoParametersTemplate_Fragment | SeriesSearchBase_VideoPressReleasePage_Fragment | SeriesSearchBase_Video_4bc649610a894242be2dc5026090cf49_Fragment | SeriesSearchBase__AssetsOptimization_Fragment | SeriesSearchBase__BackgroundImage_Fragment | SeriesSearchBase__CompatibleThemes_Fragment | SeriesSearchBase__CompositeTheme_Fragment | SeriesSearchBase__CustomMetadata_Fragment | SeriesSearchBase__CustomRenderingViewPath_Fragment | SeriesSearchBase__DatasourceBehaviour_Fragment | SeriesSearchBase__Favicon_Fragment | SeriesSearchBase__FormsFolderLocation_Fragment | SeriesSearchBase__FundSettings_Fragment | SeriesSearchBase__HasValidUrlName_Fragment | SeriesSearchBase__LocalDataLink_Fragment | SeriesSearchBase__Login_Fragment | SeriesSearchBase__OpenGraphMetadata_Fragment | SeriesSearchBase__PageDesignTheme_Fragment | SeriesSearchBase__PageSearchScope_Fragment | SeriesSearchBase__SearchCriteria_Fragment | SeriesSearchBase__SearchableWithoutRelatedItems_Fragment | SeriesSearchBase__SeoMetadata_Fragment | SeriesSearchBase__SiteTheme_Fragment | SeriesSearchBase__SitemapSettings_Fragment | SeriesSearchBase__StickyNote_Fragment | SeriesSearchBase__Styleable_Fragment | SeriesSearchBase__TwitterMetadata_Fragment | SeriesSearchBase__Webinar_Fragment | SeriesSearchBase__WildcardSource_Fragment;

export const SeriesSearchBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeriesSearchBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"D","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SeriesSearchBaseFragment, unknown>;
export const SeriesSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SeriesSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageHash"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"C0952122A4474DE7B609C921C094EBD5","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_templates","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"4E9F2E28D6FF47DBBF72CE28A860AB4E","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_name","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"EQ"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_language","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"EQ"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageHash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeriesSearchBase"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Series"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"seriesName"},"name":{"kind":"Name","value":"name_6c4025e53f294e7bbcce6e8d9bf34675"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeriesSearchBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"D","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SeriesSearchQuery, SeriesSearchQueryVariables>;